"use strict";

function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function () {
  // THE SIMULATION ENGINE, PART 3 OF 3: useSimulation, the hook every screen runs. The model
  // (engine-model.js) and reducers (engine-reducers.js) load first.
  var _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect,
    useRef = _React.useRef,
    useReducer = _React.useReducer;
  var _window = window,
    INTERVENTIONS = _window.INTERVENTIONS,
    calculateDynamicVbg = _window.calculateDynamicVbg,
    getRandomInt = _window.getRandomInt,
    clamp = _window.clamp;

  // The single shared rhythm registry. Every shockability, pulseless and
  // "is this an arrest?" decision in this file now goes through RG. The previous hardcoded
  // arrays (two shockability lists, seven arrest lists) are gone.
  var RG = window.RHYTHMS;
  // The registry's rate bands are adult. A child's sinus rhythm, sinus tachycardia or sinus
  // bradycardia takes the APLS band for their age (data/generators.js sinusRateBand), as Quick
  // Sim already does; every other rhythm keeps the registry band.
  var hrBandFor = function hrBandFor(rhythm, age) {
    var band = RG.defaultHrRange(rhythm);
    var a = Number(age);
    if (!(Number.isFinite(a) && a <= 12) || typeof window.sinusRateBand !== 'function') return band;
    var kid = window.sinusRateBand(a);
    if (rhythm === 'Sinus Rhythm') return [kid.low, kid.high];
    if (rhythm === 'Sinus Tachycardia') return [kid.high + 10, kid.high + 30];
    if (rhythm === 'Sinus Bradycardia') return [Math.max(30, kid.low - 30), kid.low - 10];
    return band;
  };
  // A scenario may state its own post-ROSC obs (scenario.roscVitals, e.g. the ALS course sheets:
  // "P 80 min-1, BP 100/60 mmHg"). Each one given replaces the generic post-ROSC value.
  var roscOwnVitals = function roscOwnVitals(scenario) {
    var authored = scenario && scenario.roscVitals && _typeof(scenario.roscVitals) === 'object' ? scenario.roscVitals : {};
    var own = {};
    ['hr', 'bpSys', 'bpDia', 'spO2', 'rr', 'gcs', 'etco2'].forEach(function (k) {
      var v = Number(authored[k]);
      if (authored[k] !== undefined && authored[k] !== null && authored[k] !== '' && Number.isFinite(v) && v >= 0) own[k] = v;
    });
    return own;
  };
  if (!RG) throw new Error('data/rhythms.js must load before data/engine.js');
  var _window$__EngineModel = window.__EngineModel,
    DEFAULT_VITALS = _window$__EngineModel.DEFAULT_VITALS,
    INVASIVE_SENSOR_KEYS = _window$__EngineModel.INVASIVE_SENSOR_KEYS,
    SENSOR_DEFS = _window$__EngineModel.SENSOR_DEFS,
    STANDARD_SENSOR_KEYS = _window$__EngineModel.STANDARD_SENSOR_KEYS,
    VENTILATOR_RATE = _window$__EngineModel.VENTILATOR_RATE,
    VOLUME_KEYS = _window$__EngineModel.VOLUME_KEYS,
    ageBandOf = _window$__EngineModel.ageBandOf,
    applyRhythmHrBand = _window$__EngineModel.applyRhythmHrBand,
    buildDrugEntry = _window$__EngineModel.buildDrugEntry,
    clampVital = _window$__EngineModel.clampVital,
    fluidResponsiveness = _window$__EngineModel.fluidResponsiveness,
    _getObstruction = _window$__EngineModel.getObstruction,
    getSensors = _window$__EngineModel.getSensors,
    _getUnmetExpectations = _window$__EngineModel.getUnmetExpectations,
    initialCoreState = _window$__EngineModel.initialCoreState,
    initialLogState = _window$__EngineModel.initialLogState,
    initialScenarioState = _window$__EngineModel.initialScenarioState,
    initialVitalsState = _window$__EngineModel.initialVitalsState,
    isDrugSpent = _window$__EngineModel.isDrugSpent,
    isVentilated = _window$__EngineModel.isVentilated,
    keywordObjectivesFor = _window$__EngineModel.keywordObjectivesFor,
    normaliseDeteriorationType = _window$__EngineModel.normaliseDeteriorationType,
    isAnaphylaxisScenario = _window$__EngineModel.isAnaphylaxisScenario,
    paediatricAdenosineDose = _window$__EngineModel.paediatricAdenosineDose,
    paediatricDoseNotes = _window$__EngineModel.paediatricDoseNotes,
    paediatricFieldScale = _window$__EngineModel.paediatricFieldScale,
    pkFactor = _window$__EngineModel.pkFactor,
    pkPhase = _window$__EngineModel.pkPhase,
    pkRemaining = _window$__EngineModel.pkRemaining,
    newRunId = _window$__EngineModel.newRunId,
    sanitizeForRealtimeDatabase = _window$__EngineModel.sanitizeForRealtimeDatabase,
    scenarioText = _window$__EngineModel.scenarioText,
    tickActionFor = _window$__EngineModel.tickActionFor;
  var _window$__EngineReduc = window.__EngineReducers,
    coreReducer = _window$__EngineReduc.coreReducer,
    logReducer = _window$__EngineReduc.logReducer,
    scenarioReducer = _window$__EngineReduc.scenarioReducer,
    vitalsReducer = _window$__EngineReduc.vitalsReducer;

  // The shared output stage for one AudioContext, built once and cached on it. Every sound is
  // boosted x4 (+12 dB) and then soft-limited: anything above 0.7 of full scale is rounded off
  // towards 1.0 instead of clipping harshly, so the quiet tones (a pulse beep peaked at 0.1) come
  // up a lot while the loud ones (shock, cuff, two at once) do not distort. A curve is used rather
  // than a DynamicsCompressor because Chrome's compressor barely raised the short beeps.
  // The defib (defib/index.html) and ventilator (vent/index.html) pages carry their own copy.
  var simSoundOut = function simSoundOut(ctx) {
    if (ctx.__simOut) return ctx.__simOut;
    try {
      var _ctx$__simVolume;
      var BOOST = 4;
      var N = 2049,
        c = new Float32Array(N);
      for (var i = 0; i < N; i++) {
        var x = i / (N - 1) * 2 - 1,
          a = Math.abs(x) * BOOST;
        c[i] = Math.sign(x) * (a <= 0.7 ? a : 0.7 + 0.3 * Math.tanh((a - 0.7) / 0.3));
      }
      var shaper = ctx.createWaveShaper();
      shaper.curve = c;
      shaper.oversample = 'none';
      shaper.connect(ctx.destination);
      // The controller's volume (setSimVolume) sits in front of the limiter, so above 100% the
      // quieter sounds keep getting louder while the loud ones stay just under clipping.
      var volume = ctx.createGain();
      volume.gain.value = (_ctx$__simVolume = ctx.__simVolume) !== null && _ctx$__simVolume !== void 0 ? _ctx$__simVolume : 1;
      volume.connect(shaper);
      ctx.__simVol = volume;
      ctx.__simOut = volume;
    } catch (e) {
      ctx.__simOut = ctx.destination;
    }
    return ctx.__simOut;
  };
  window.simSoundOut = simSoundOut;
  var setSimVolume = function setSimVolume(ctx, v) {
    if (!ctx) return;
    ctx.__simVolume = v;
    if (ctx.__simVol) {
      try {
        ctx.__simVol.gain.setTargetAtTime(v, ctx.currentTime, 0.05);
      } catch (e) {
        ctx.__simVol.gain.value = v;
      }
    }
  };
  var useSimulation = function useSimulation(initialScenario) {
    var isMonitorMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var sessionID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var _useReducer = useReducer(vitalsReducer, initialVitalsState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      vitalsState = _useReducer2[0],
      rawDispatchVitals = _useReducer2[1];
    var _useReducer3 = useReducer(logReducer, initialLogState),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      logState = _useReducer4[0],
      rawDispatchLog = _useReducer4[1];
    var _useReducer5 = useReducer(scenarioReducer, initialScenarioState),
      _useReducer6 = _slicedToArray(_useReducer5, 2),
      scenarioState = _useReducer6[0],
      rawDispatchScenario = _useReducer6[1];
    var _useReducer7 = useReducer(coreReducer, initialCoreState),
      _useReducer8 = _slicedToArray(_useReducer7, 2),
      coreState = _useReducer8[0],
      rawDispatchCore = _useReducer8[1];
    var state = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, vitalsState), logState), scenarioState), coreState);

    // ---- stateRef IS ALWAYS CURRENT ------------------------------------------------------------
    // Engine functions read the latest state through stateRef, but React only re-renders after an
    // event handler or timer has finished, so two dispatches in the same moment used to see the
    // state from BEFORE the first one (three quick doses all counted as dose 1; a rhythm change
    // followed by an obs write could undo itself). Every dispatch therefore also runs the same
    // pure reducer on a shadow copy and updates stateRef at once. React's own result replaces
    // the shadow at the next render, so the two can differ at most by a timestamp.
    var REDUCERS = {
      vitals: vitalsReducer,
      log: logReducer,
      scenario: scenarioReducer,
      core: coreReducer
    };
    var renderedRef = useRef(null);
    var shadowRef = useRef(null);
    renderedRef.current = {
      vitals: vitalsState,
      log: logState,
      scenario: scenarioState,
      core: coreState
    };
    shadowRef.current = null;
    var applyShadow = function applyShadow(key, action) {
      var base = shadowRef.current || renderedRef.current;
      var next = base[key];
      try {
        next = REDUCERS[key](base[key], action);
      } catch (e) {/* React will surface it */}
      var s = _objectSpread(_objectSpread({}, base), {}, _defineProperty({}, key, next));
      shadowRef.current = s;
      stateRef.current = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, s.vitals), s.log), s.scenario), s.core);
    };
    var dispatchVitals = function dispatchVitals(a) {
      applyShadow('vitals', a);
      rawDispatchVitals(a);
    };
    var dispatchLog = function dispatchLog(a) {
      applyShadow('log', a);
      rawDispatchLog(a);
    };
    var dispatchScenario = function dispatchScenario(a) {
      applyShadow('scenario', a);
      rawDispatchScenario(a);
    };
    var dispatchCore = function dispatchCore(a) {
      applyShadow('core', a);
      rawDispatchCore(a);
    };
    var timerRef = useRef(null);
    var tickRef = useRef(null);
    var audioCtxRef = useRef(null);
    var loopNodesRef = useRef({});
    var stateRef = useRef(state);
    var lastCmdRef = useRef(0);
    var lastPayloadRef = useRef({});

    // The local defib bridge is optional — everything clinical goes over Firebase. Older iOS
    // Safari and locked-down MDM profiles have no BroadcastChannel, and throwing here would
    // blank the whole controller before the ErrorBoundary could render a fallback.
    var simChannel = useRef(null);
    var channelReady = useRef(false);
    if (!channelReady.current) {
      channelReady.current = true;
      try {
        simChannel.current = 'BroadcastChannel' in window ? new BroadcastChannel('sim_channel') : null;
      } catch (e) {
        console.warn('BroadcastChannel unavailable — defib bridge disabled', e);
        simChannel.current = null;
      }
    }
    var postToChannel = function postToChannel(msg) {
      if (simChannel.current) {
        try {
          simChannel.current.postMessage(msg);
        } catch (e) {
          console.warn('Channel post failed', e);
        }
      }
    };

    // Only when nothing was dispatched since this render: a dispatch landing between React's
    // commit and this effect has already moved stateRef on (applyShadow), and overwriting it
    // with the rendered state would roll that dispatch back for the engine (an arrest that the
    // next drug did not see, so the drug put a BP back on a pulseless patient).
    useEffect(function () {
      if (!shadowRef.current) stateRef.current = state;
    }, [state]);

    // ---- ONE RULE FOR WHEN THE PATIENT GOES LIVE ------------------------------------------------
    // Every launch mode (Quick Sim, a library scenario, Defib Sim, Ventilator Sim, a resumed
    // session) waits for START. Until then nothing physiological moves: no trends, no
    // deterioration, no drug effects and no timed drug events. Drugs and interventions given
    // before START are still recorded (log, interventionCounts, activeInterventions); their
    // pk entries cannot act because the sim clock (state.time) does not move, and their instant
    // effects wait in pendingEffectsRef and are applied when START is pressed. "Not started" is
    // told apart from a deliberate pause by pausedAt, which only PAUSE_SIM sets.
    var _notStarted = function notStarted(s) {
      return !!s && !s.isRunning && !s.isFinished && (s.pausedAt === null || s.pausedAt === undefined);
    };
    var pendingEffectsRef = useRef([]); // [{ key, label (null: nothing to announce), fn(now) }]
    var deferUntilStart = function deferUntilStart(key, label, fn) {
      pendingEffectsRef.current.push({
        key: key,
        label: label,
        fn: fn
      });
    };
    var dropPendingEffects = function dropPendingEffects(key) {
      pendingEffectsRef.current = pendingEffectsRef.current.filter(function (p) {
        return p.key !== key;
      });
    };

    // ---- SIM-CLOCK TIMERS ------------------------------------------------------------------------
    // Delayed consequences (sugammadex reversal, VF recurring after ROSC, a drug's rhythm effect)
    // used to be wall-clock setTimeouts: they kept counting while the scenario was paused and
    // fired into whatever scenario had been loaded since. These count down only while the
    // clock runs (not before START, not while paused), and die with the run that scheduled
    // them (runId) or when the session finishes.
    // The instant (no-pk) change each running continuous intervention made to the base vitals
    // ({ [key]: { runId, arrest, deltas } }), so removing BVM, pacing, CPR, the LUCAS or an
    // airway adjunct takes its effect off again instead of leaving it in the base for good.
    var instantDeltasRef = useRef({});
    var REVERSIBLE_INSTANT = ['Bagging', 'Pacing', 'CPR', 'Lucas', 'OPA', 'NPA'];
    var simTimersRef = useRef(new Set());
    var clearSimTimer = function clearSimTimer(id) {
      if (id === null || id === undefined) return;
      clearInterval(id);
      simTimersRef.current["delete"](id);
    };
    var clearSimTimers = function clearSimTimers() {
      simTimersRef.current.forEach(function (id) {
        return clearInterval(id);
      });
      simTimersRef.current.clear();
    };
    var simTimeout = function simTimeout(fn, seconds) {
      var runId = stateRef.current ? stateRef.current.runId : null;
      var left = Math.max(0, Math.round(Number(seconds) || 0));
      var id = setInterval(function () {
        var now = stateRef.current;
        if (!now || now.runId !== runId || now.isFinished) {
          clearSimTimer(id);
          return;
        }
        if (!now.isRunning) return;
        left -= 1;
        if (left > 0) return;
        clearSimTimer(id);
        fn();
      }, 1000);
      simTimersRef.current.add(id);
      return id;
    };
    useEffect(function () {
      return function () {
        return clearSimTimers();
      };
    }, []);
    var _dispatch = function dispatch(action) {
      // A new run's id is decided here, once, so the shadow copy and React agree on it.
      if ((action.type === 'LOAD_SCENARIO' || action.type === 'RESTORE_SESSION') && !action.runId) action = _objectSpread(_objectSpread({}, action), {}, {
        runId: newRunId()
      });
      // Nothing scheduled by the previous run may fire into the new one.
      if (action.type === 'LOAD_SCENARIO' || action.type === 'RESTORE_SESSION' || action.type === 'CLEAR_SESSION') {
        clearSimTimers();
        pendingEffectsRef.current = [];
      }
      var enhancedAction = _objectSpread(_objectSpread({}, action), {}, {
        currentState: stateRef.current
      });

      // A pulseless patient has no BP or saturation to trend: Better/Worse (or a stabilising
      // drug) during an arrest used to ramp BP and SpO2 up from 0 on a patient in VF or
      // asystole. The trend waits for ROSC; the flash still shows the button registered.
      if ((action.type === 'TRIGGER_IMPROVE' || action.type === 'TRIGGER_DETERIORATE') && RG.inArrest(stateRef.current.rhythm)) {
        _dispatch({
          type: 'SET_FLASH',
          payload: action.type === 'TRIGGER_IMPROVE' ? 'green' : 'red'
        });
        _dispatch({
          type: 'SET_NOTIFICATION',
          payload: {
            msg: 'In cardiac arrest: the obs stay at zero until ROSC.',
            type: 'info',
            id: Date.now()
          }
        });
        return;
      }

      // Better/Worse move the scenario's gas; the gas's pH and K+ are the patient's own
      // (window.liveVbg), so the same change goes into the trend for pH and K+.
      var gasTargets = function gasTargets(targets, from, to) {
        var b = stateRef.current.baseVitals || {};
        [['ph', 'pH'], ['k', 'K']].forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            vk = _ref2[0],
            gk = _ref2[1];
          var d = Number(to[gk]) - Number(from[gk]);
          if (targets[vk] === undefined && Number.isFinite(b[vk]) && Number.isFinite(d) && d !== 0) targets[vk] = b[vk] + d;
        });
      };
      if (action.type === 'TRIGGER_IMPROVE') {
        var impTargets = {};
        var scen = stateRef.current.scenario;
        var vits = stateRef.current.vitals;
        if (scen && scen.evolution && scen.evolution.improved && scen.evolution.improved.vitals) {
          impTargets = _objectSpread({}, scen.evolution.improved.vitals);
        } else {
          impTargets.hr = Math.max(60, vits.hr - 15);
          impTargets.bpSys = Math.min(120, vits.bpSys + 15);
          impTargets.spO2 = Math.min(99, vits.spO2 + 5);
        }
        // Trends operate in BASE space (see the precedence comment): snapshot the base, not
        // the displayed vitals, or the trend would swallow whatever the drugs are contributing.
        if (scen !== null && scen !== void 0 && scen.vbg && window.calculateDynamicVbg) {
          var nextVbg = window.calculateDynamicVbg(scen.vbg, vits, stateRef.current.activeInterventions, 0, 'improve');
          gasTargets(impTargets, scen.vbg, nextVbg);
          dispatchScenario({
            type: 'UPDATE_SCENARIO',
            payload: _objectSpread(_objectSpread({}, scen), {}, {
              vbg: nextVbg
            }),
            currentState: stateRef.current
          });
        }
        enhancedAction = _objectSpread(_objectSpread({}, enhancedAction), {}, {
          payload: {
            trends: {
              active: true,
              targets: impTargets,
              duration: 30,
              elapsed: 0,
              startVitals: _objectSpread({}, stateRef.current.baseVitals)
            }
          }
        });
        dispatchCore({
          type: 'SET_FLASH',
          payload: 'green',
          currentState: stateRef.current
        });
      }
      if (action.type === 'TRIGGER_DETERIORATE') {
        var detTargets = {};
        var _scen = stateRef.current.scenario;
        var _vits = stateRef.current.vitals;
        if (_scen && _scen.evolution && _scen.evolution.deteriorated && _scen.evolution.deteriorated.vitals) {
          detTargets = _objectSpread({}, _scen.evolution.deteriorated.vitals);
        } else {
          detTargets.hr = Math.min(170, _vits.hr + 20);
          detTargets.bpSys = Math.max(60, _vits.bpSys - 20);
          detTargets.spO2 = Math.max(80, _vits.spO2 - 10);
        }
        if (_scen !== null && _scen !== void 0 && _scen.vbg && window.calculateDynamicVbg) {
          var _nextVbg = window.calculateDynamicVbg(_scen.vbg, _vits, stateRef.current.activeInterventions, 0, 'deteriorate');
          gasTargets(detTargets, _scen.vbg, _nextVbg);
          dispatchScenario({
            type: 'UPDATE_SCENARIO',
            payload: _objectSpread(_objectSpread({}, _scen), {}, {
              vbg: _nextVbg
            }),
            currentState: stateRef.current
          });
        }
        enhancedAction = _objectSpread(_objectSpread({}, enhancedAction), {}, {
          payload: {
            trends: {
              active: true,
              targets: detTargets,
              duration: 30,
              elapsed: 0,
              startVitals: _objectSpread({}, stateRef.current.baseVitals)
            }
          }
        });
        dispatchCore({
          type: 'SET_FLASH',
          payload: 'red',
          currentState: stateRef.current
        });
      }
      if (action.type === 'UPDATE_RHYTHM') {
        var newRhythm = RG.canonical(action.payload);
        // ONE definition. `pulseless` and `isArrest` are the SAME registry predicate —
        // the pre-Wave-3 code had two different lists here that disagreed about VT, so
        // VT-with-a-pulse got arrest physiology while also being excluded from zeroing.
        var isArrest = RG.inArrest(newRhythm);
        var cur = stateRef.current;
        // Rhythm-driven vitals are a facilitator-level write: they target the BASE.
        var rhythmVitals = _objectSpread({}, cur.baseVitals);

        // Does the facilitator hold HR? A pulseless/organised transition
        // releases the hold (it defines a new baseline); an organised -> organised rhythm
        // change respects it.
        var releaseManual = [];
        // Crossing into or out of arrest sets a new baseline, so earlier instant effects are
        // no longer there to be taken off.
        if (RG.isPulseless(newRhythm) !== RG.isPulseless(cur.rhythm)) instantDeltasRef.current = {};
        if (RG.isPulseless(newRhythm)) {
          // A shockable/pulseless rhythm showing a pre-arrest BP and SpO2 is clinically
          // contradictory; the numeric panel must agree with the trace.
          if (rhythmVitals.hr > 0 || rhythmVitals.bpSys > 0) {
            dispatchVitals({
              type: 'STOP_TREND',
              currentState: cur
            });
            rhythmVitals = _objectSpread(_objectSpread({}, rhythmVitals), {}, {
              hr: 0,
              bpSys: 0,
              bpDia: 0,
              spO2: 0,
              rr: 0,
              gcs: 3,
              pupils: 'Dilated',
              etco2: 1.5
            });
            releaseManual = ['hr', 'bpSys', 'bpDia', 'spO2', 'rr', 'gcs', 'pupils', 'etco2'];
          }
        } else if (RG.isPulseless(cur.rhythm)) {
          var _cur$scenario$patient, _cur$scenario;
          // Coming out of a pulseless rhythm into an organised one — an organised rhythm must
          // never be left displaying HR 0.
          var age = (_cur$scenario$patient = (_cur$scenario = cur.scenario) === null || _cur$scenario === void 0 ? void 0 : _cur$scenario.patientAge) !== null && _cur$scenario$patient !== void 0 ? _cur$scenario$patient : 40;
          var base = window.getBaseVitals ? window.getBaseVitals(age) : {
            hr: 80,
            rr: 16,
            bpSys: 110,
            bpDia: 70
          };
          dispatchVitals({
            type: 'STOP_TREND',
            currentState: cur
          });
          rhythmVitals = _objectSpread(_objectSpread({}, rhythmVitals), {}, {
            hr: base.hr,
            bpSys: base.bpSys,
            bpDia: base.bpDia,
            spO2: 94,
            rr: base.rr,
            gcs: 8,
            pupils: 3,
            etco2: Math.round((5.0 + Math.random() * 1.5) * 10) / 10
          }, roscOwnVitals(cur.scenario));
          releaseManual = ['hr', 'bpSys', 'bpDia', 'spO2', 'rr', 'gcs', 'pupils', 'etco2'];
        }
        // The scenario's own post-ROSC heart rate is kept, not re-rolled from the rhythm's band.
        var ownRoscHr = RG.isPulseless(cur.rhythm) && !isArrest && roscOwnVitals(cur.scenario).hr !== undefined;

        // Registry-supplied rate band for the new rhythm, so every organised rhythm
        // (including the ones previously missing: Atrial Flutter, VT, 1st/2nd degree block,
        // Junctional, STEMI) lands on a clinically sensible heart rate.
        //
        // FACILITATOR SUPREMACY. The band is applied only when the
        // facilitator has NOT typed an HR of their own (or has just had the hold released by
        // an arrest/ROSC transition above). If they have, their number stands and the rhythm
        // change says so in the log, rather than silently replacing 130 with 140.
        //
        // Whether the Defib or arrest panel happens to be open no longer matters (a cardioverted
        // SVT used to read "Sinus Rhythm" at 195 because the panel was open). An "unchanged"
        // transition (a failed shock or cardioversion) keeps the current rate rather than
        // re-rolling it.
        if (!isArrest && newRhythm !== RG.canonical(cur.rhythm) && !ownRoscHr) {
          var _cur$scenario2;
          var band = hrBandFor(newRhythm, (_cur$scenario2 = cur.scenario) === null || _cur$scenario2 === void 0 ? void 0 : _cur$scenario2.patientAge);
          var stillHeld = !applyRhythmHrBand(cur, releaseManual);
          if (band && !stillHeld) {
            rhythmVitals.hr = getRandomInt(band[0], band[1]);
          } else if (band && stillHeld) {
            var shown = Math.round(cur.vitals.hr);
            dispatchLog({
              type: 'ADD_LOG',
              currentState: cur,
              payload: {
                msg: "HR left at your manual value of ".concat(shown, " for ").concat(RG.labelFor(newRhythm), " (typical ").concat(band[0], "-").concat(band[1], "/min). Manual values always win \u2014 set HR again from the HR tile to change it."),
                type: 'info',
                flagged: false,
                deviation: null
              }
            });
          }
        }
        dispatchVitals({
          type: 'UPDATE_VITALS',
          payload: rhythmVitals,
          releaseManual: releaseManual,
          forceArrest: isArrest,
          currentState: stateRef.current
        });
      }

      // Taking a continuous intervention off undoes the instant change it made to the base
      // (see instantDeltasRef), whichever screen removed it.
      var reversal = null;
      if (action.type === 'REMOVE_INTERVENTION') {
        var rec = instantDeltasRef.current[action.payload];
        delete instantDeltasRef.current[action.payload];
        var _cur = stateRef.current;
        // Not across an arrest or ROSC (that transition wrote new obs of its own), not into a
        // different run, and never over a value the facilitator has typed since.
        if (rec && _cur.activeInterventions.has(action.payload) && rec.runId === _cur.runId && !RG.inArrest(_cur.rhythm) && !rec.arrest) {
          var hold = _cur.manualHold || {};
          reversal = {};
          Object.keys(rec.deltas).forEach(function (f) {
            var bv = Number(_cur.baseVitals[f]);
            if ((!hold[f] || rec.held[f]) && Number.isFinite(bv)) reversal[f] = clampVital(f, bv - rec.deltas[f]);
          });
        }
      }
      if (action.type === 'LOAD_SCENARIO' || action.type === 'RESTORE_SESSION' || action.type === 'CLEAR_SESSION') instantDeltasRef.current = {};
      dispatchVitals(enhancedAction);
      dispatchLog(enhancedAction);
      dispatchScenario(enhancedAction);
      dispatchCore(enhancedAction);
      if (reversal && Object.keys(reversal).length) dispatchVitals({
        type: 'UPDATE_VITALS',
        payload: reversal,
        currentState: stateRef.current
      });
    };
    // THE SIMULATION ENGINE: LIVE SESSION SYNC (data/engine-sync.js).
    var _window$__EngineSync$ = window.__EngineSync.useSessionSync({
        addLogEntry: function addLogEntry() {
          return _addLogEntry.apply(void 0, arguments);
        },
        analyseRhythm: function analyseRhythm() {
          return _analyseRhythm.apply(void 0, arguments);
        },
        deliverShock: function deliverShock() {
          return _deliverShock.apply(void 0, arguments);
        },
        dispatch: _dispatch,
        initCharge: function initCharge() {
          return _initCharge.apply(void 0, arguments);
        },
        isAudioLive: function isAudioLive() {
          return _isAudioLive.apply(void 0, arguments);
        },
        isMonitorMode: isMonitorMode,
        lastPayloadRef: lastPayloadRef,
        postToChannel: postToChannel,
        sessionID: sessionID,
        setDefibEnergy: function setDefibEnergy() {
          return _setDefibEnergy.apply(void 0, arguments);
        },
        setDefibMode: function setDefibMode() {
          return _setDefibMode.apply(void 0, arguments);
        },
        simChannel: simChannel,
        start: function start() {
          return _start.apply(void 0, arguments);
        },
        state: state,
        stateRef: stateRef,
        toggleCPR: function toggleCPR() {
          return _toggleCPR.apply(void 0, arguments);
        }
      }),
      sendDeviceEvent = _window$__EngineSync$.sendDeviceEvent,
      sendVentCommand = _window$__EngineSync$.sendVentCommand;
    // The context is created at mount (before any gesture) so it is born 'suspended' under the
    // autoplay policy. The "Tap to Enable Sound" overlay resumes THIS ref, which is correct; what
    // was missing was recovery when iOS/tab-backgrounding re-suspends it, so watch statechange.
    var _useState = useState('unknown'),
      _useState2 = _slicedToArray(_useState, 2),
      audioCtxState = _useState2[0],
      setAudioCtxState = _useState2[1];
    // Safari has a third state, 'interrupted' (screen lock, a call, Siri, another app's audio):
    // it needs the same resume as 'suspended', and checking only 'suspended' left iPads silent.
    var audioBlocked = function audioBlocked(ctx) {
      return !!ctx && ctx.state !== 'running' && ctx.state !== 'closed';
    };
    // Every sound goes through simSoundOut (above): the tones were written quietly, so even at full
    // device volume a room monitor was hard to hear.
    var soundOut = simSoundOut;
    useEffect(function () {
      if (!audioCtxRef.current) {
        var AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        try {
          audioCtxRef.current = new AudioContext();
        } catch (e) {
          console.warn('AudioContext unavailable', e);
          return;
        }
      }
      var ctx = audioCtxRef.current;
      setAudioCtxState(ctx.state);
      // Also before any tap, for a Safari that is set to allow sound on this site (see unmuteIos).
      try {
        if (navigator.audioSession) navigator.audioSession.type = 'playback';
      } catch (e) {}
      var onStateChange = function onStateChange() {
        setAudioCtxState(ctx.state);
        // Re-suspension is common on iOS and when a tab is backgrounded. Try to recover
        // immediately; if the browser refuses without a gesture the overlay can be re-shown.
        if (audioBlocked(ctx)) {
          try {
            ctx.resume()["catch"](function () {});
          } catch (e) {}
        }
      };
      ctx.addEventListener('statechange', onStateChange);
      // iOS only lets a context resume inside a user gesture, so any tap or key press on the
      // page is used to wake a context that has been (re-)suspended; otherwise the cuff,
      // charge and alarm sounds stay silent until someone finds the "enable sound" button.
      // enableAudio (below) also unlocks speech on iOS, as the monitor's button does, now that the button
      // hides itself once sound is on.
      // On an iPad a finger's pointerdown/touchstart does not count as a gesture for audio; only the
      // touchend/click that follow do, so listen for those too.
      var onGesture = function onGesture() {
        if (audioBlocked(ctx)) enableAudio();
      };
      var GESTURES = ['pointerdown', 'keydown', 'touchend', 'click'];
      GESTURES.forEach(function (t) {
        return document.addEventListener(t, onGesture, true);
      });
      return function () {
        ctx.removeEventListener('statechange', onStateChange);
        GESTURES.forEach(function (t) {
          return document.removeEventListener(t, onGesture, true);
        });
      };
    }, []);

    // Resume + prime. Some iOS builds only truly unlock output once a buffer has been *played*
    // inside the user gesture, so push a one-sample silent buffer through as well.
    var resumeAudio = function resumeAudio() {
      var prime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var ctx = audioCtxRef.current;
      if (!ctx) return Promise.resolve(false);
      var primeSilence = function primeSilence() {
        if (!prime) return;
        try {
          var buffer = ctx.createBuffer(1, 1, ctx.sampleRate);
          var source = ctx.createBufferSource();
          source.buffer = buffer;
          source.connect(ctx.destination);
          source.start(0);
        } catch (e) {/* priming is best-effort */}
      };
      // Prime first, synchronously: iOS only counts what happens inside the gesture itself, and a
      // buffer started after the resume promise settles is already outside it.
      primeSilence();
      if (audioBlocked(ctx)) {
        try {
          var p = ctx.resume();
          if (p && typeof p.then === 'function') {
            return p.then(function () {
              setAudioCtxState(ctx.state);
              return ctx.state === 'running';
            })["catch"](function (e) {
              console.warn('AudioContext resume failed', e);
              setAudioCtxState(ctx.state);
              return false;
            });
          }
        } catch (e) {
          console.warn('AudioContext resume threw', e);
          return Promise.resolve(false);
        }
        return Promise.resolve(ctx.state === 'running');
      }
      return Promise.resolve(ctx.state === 'running');
    };

    // Is this device the one that should be making noise right now?
    // Should the pulse tone and physiological alarms sound at all? Only while the clock runs, in
    // every launch mode: before START the patient is not live yet (Quick Sim used to be audible
    // from launch because it never pressed START). The controller publishes the answer as
    // `audioLive` for the team monitor.
    var _isAudioLive = function _isAudioLive(current) {
      if (isMonitorMode && current.audioLive !== undefined) return !!current.audioLive;
      return !!current.isRunning;
    };
    // ONE patient screen makes the monitor's sounds. Several screens can join a session (one computer
    // opens a window per screen), and each runs its own clock: two of them beeping the pulse gave the
    // room two trains of beeps drifting in and out of step (Jake, 15 Oct 2026). Each screen reads the
    // same presence list (data/engine-sync.js), so they all pick the same one, without a rules change:
    // the connected screen showing the monitor with the lowest id. A screen showing only the defib or
    // the ventilator never makes them; the device pages keep their own sounds.
    var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      soundScreen = _useState4[0],
      setSoundScreen = _useState4[1];
    var soundScreenRef = useRef(true);
    var localScreen = state.localScreen;
    useEffect(function () {
      var S = window.SimScreens,
        db = window.db;
      var set = function set(v) {
        soundScreenRef.current = v;
        setSoundScreen(v);
      };
      if (!isMonitorMode || !sessionID || !db || !S) {
        set(true);
        return;
      }
      var showsMonitor = function showsMonitor(role) {
        return S.partsOf(role).includes('monitor');
      };
      var me = localScreen;
      var latest = {};
      var decide = function decide() {
        if (!me || !me.id) {
          set(true);
          return;
        } // not yet a screen: nothing to share with
        if (!showsMonitor(me.role)) {
          set(false);
          return;
        }
        var now = Date.now();
        var ids = Object.keys(latest).filter(function (k) {
          var c = latest[k] || {};
          return typeof c.role === 'string' && c.role.startsWith('screen:') && showsMonitor(c.role.slice(7)) && Number.isFinite(Number(c.ts)) && Math.abs(now - Number(c.ts)) < 30000;
        });
        if (!ids.includes(me.id)) ids.push(me.id);
        ids.sort();
        set(ids[0] === me.id);
      };
      var ref = db.ref("sessions/".concat(sessionID, "/presence"));
      var onVal = function onVal(snap) {
        latest = snap && snap.val() || {};
        decide();
      };
      ref.on('value', onVal, function () {
        latest = {};
        decide();
      });
      var sweep = setInterval(decide, 5000);
      decide();
      return function () {
        ref.off('value', onVal);
        clearInterval(sweep);
      };
    }, [isMonitorMode, sessionID, localScreen && localScreen.id, localScreen && localScreen.role]);
    var isAudioRouted = function isAudioRouted(current) {
      return isMonitorMode && soundScreenRef.current && (current.audioOutput === 'monitor' || current.audioOutput === 'both') || !isMonitorMode && (current.audioOutput === 'controller' || current.audioOutput === 'both');
    };

    // Pulse-oximeter beep. Every early exit now RESCHEDULES: previously a manual rhythm change to
    // pVT/VF with a non-zero HR exited the loop permanently (and `rhythm` was not a dependency),
    // killing audio for the rest of the session with no way back.
    useEffect(function () {
      var timerId;
      var cancelled = false;
      // No pulse means no beep. Registry-derived, so it cannot drift from the
      // physiology the way the old private list did.
      var SILENT_RHYTHMS = RG.PULSELESS;
      var _scheduleBeep = function scheduleBeep() {
        if (cancelled) return;
        var current = stateRef.current;
        var ctx = audioCtxRef.current;
        var retry = function retry(ms) {
          timerId = setTimeout(_scheduleBeep, ms);
        };
        if (!_isAudioLive(current)) {
          retry(1000);
          return;
        }
        if (current.vitals.hr <= 0 || SILENT_RHYTHMS.includes(current.rhythm)) {
          retry(1000);
          return;
        }
        // Follows the INDIVIDUAL sensors, not the 'Obs' shorthand: detaching one standard
        // sensor expands 'Obs' into its individual keys, so keying on 'Obs' silenced the beep
        // as soon as anything was removed, and a lone SpO2 probe never beeped at all.
        // The pulse tone comes from the SpO2 probe or, with no probe on, the ECG (QRS tone).
        var beepSensors = getSensors(current);
        if (!beepSensors.spo2 && !beepSensors.ecg) {
          retry(1000);
          return;
        }
        if (!current.isMuted && ctx && isAudioRouted(current)) {
          if (audioBlocked(ctx)) {
            resumeAudio();
            retry(500);
            return;
          }
          try {
            var osc = ctx.createOscillator();
            var gain = ctx.createGain();
            osc.type = 'sine';
            var spO2 = current.vitals.spO2;
            // Real oximeters keep dropping in pitch well below 85%. The old mapping clamped
            // at 400 Hz from 85% downwards — exactly where the cue matters most. Now the
            // tone continues to fall to a floor of 180 Hz at 50%, and stays recognisable.
            var freq = 800;
            // Pitch tracks saturation only when a probe is actually measuring it.
            if (!beepSensors.spo2) freq = 800;else if (spO2 >= 85) freq = 400 + (spO2 - 85) * (400 / 15);else freq = Math.max(180, 400 - (85 - spO2) * (220 / 35));
            osc.frequency.value = Math.max(120, Math.min(900, freq));
            osc.connect(gain);
            gain.connect(soundOut(ctx));
            var now = ctx.currentTime;
            gain.gain.setValueAtTime(0, now);
            gain.gain.linearRampToValueAtTime(0.1, now + 0.01);
            gain.gain.exponentialRampToValueAtTime(0.001, now + 0.15);
            osc.start(now);
            osc.stop(now + 0.2);
          } catch (e) {
            console.warn('Beep failed', e);
          }
        }
        retry(60000 / (Math.max(20, current.vitals.hr) || 60));
      };
      resumeAudio();
      _scheduleBeep();
      return function () {
        cancelled = true;
        clearTimeout(timerId);
      };
    }, [isMonitorMode, audioCtxState]);

    // PHYSIOLOGICAL ALARMS. These used to exist only on the facilitator's laptop (livesim.js had
    // its own separate AudioContext), so trainees could never hear a desat or brady alarm on the
    // device that in real life screams. They now live in shared engine code, run on whichever
    // device `audioOutput` routes to, and are driven by the synced vitals.
    var lastAlarmRef = useRef({});
    var playAlertTone = function playAlertTone(type) {
      var ctx = audioCtxRef.current;
      if (!ctx) return;
      try {
        if (audioBlocked(ctx)) {
          resumeAudio();
          return;
        }
        var osc = ctx.createOscillator();
        var gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(soundOut(ctx));
        osc.frequency.value = type === 'critical' ? 880 : 660;
        osc.type = 'sine';
        gain.gain.setValueAtTime(0.3, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
        osc.start(ctx.currentTime);
        osc.stop(ctx.currentTime + 0.5);
      } catch (e) {/* never let an alarm take down the sim */}
    };
    useEffect(function () {
      var _current$scenario$pat, _current$scenario;
      var current = state;
      if (!_isAudioLive(current) || current.isMuted) return;
      if (!isAudioRouted(current)) return;
      // Each alarm is watched only by the sensor that measures it — same rule as the beep.
      // (This used to key on the 'Obs' shorthand, which disappears as soon as any single
      // standard sensor is detached, so removing one probe silenced every alarm.)
      var alarmSensors = getSensors(current);
      var pulseWatched = alarmSensors.ecg || alarmSensors.spo2;
      if (!pulseWatched) return;
      var age = (_current$scenario$pat = (_current$scenario = current.scenario) === null || _current$scenario === void 0 ? void 0 : _current$scenario.patientAge) !== null && _current$scenario$pat !== void 0 ? _current$scenario$pat : 40;
      var th = window.getAlarmThresholds && window.getAlarmThresholds(age) || {
        hr: {
          low: 40,
          high: 130
        },
        rr: {
          low: 8,
          high: 30
        },
        spO2: 90
      };
      var v = current.vitals || {};
      var now = Date.now();
      var fire = function fire(key, tone) {
        if (now - (lastAlarmRef.current[key] || 0) > 10000) {
          playAlertTone(tone);
          lastAlarmRef.current[key] = now;
        }
      };
      var pulseless = RG.isPulseless(current.rhythm); // Registry
      if (pulseless) {
        fire('arrest', 'critical');
        return;
      }
      if (v.hr > th.hr.high || v.hr < th.hr.low) fire('hr', 'critical');
      if (alarmSensors.spo2 && v.spO2 < th.spO2) fire('spO2', 'critical');
      // Respiratory rate is chest-wall impedance off the ECG electrodes.
      if (alarmSensors.ecg && (v.rr < th.rr.low || v.rr > th.rr.high)) fire('rr', 'alert');
    }, [state.vitals.hr, state.vitals.spO2, state.vitals.rr, state.rhythm, state.isRunning, state.isMuted, state.audioOutput, isMonitorMode, state.activeInterventions, state.audioLive, state.pausedAt, soundScreen]);

    // Auto mode only measures while a cuff is actually on (it resumes when the cuff goes back on).
    // The countdown rides the sim clock (TICK_TIME), so it waits for START like everything else;
    // a reading can still be taken by hand before then.
    useEffect(function () {
      if (state.nibp.mode === 'auto' && state.nibp.timer <= 0 && state.isRunning && !state.nibp.inflating && getSensors(state).nibp) {
        _dispatch({
          type: 'START_NIBP'
        });
      }
    }, [state.nibp.timer, state.nibp.mode, state.isRunning, state.nibp.inflating, state.activeInterventions]);
    // The measurement itself: ~5 s of inflation, then the reading is committed. This is its OWN
    // effect, keyed only on `inflating`. It used to share the auto-trigger effect above, whose
    // dependencies include the auto-mode countdown — which changes every second while the sim
    // runs — so each tick cancelled the commit and restarted the inflation sound, and an
    // auto-mode reading never completed.
    useEffect(function () {
      if (!state.nibp.inflating) return;
      // The cuff noise comes from whichever device is set to make the sound ("Sound plays on").
      if (isAudioRouted(stateRef.current)) playInflationSound();
      var timeout = setTimeout(function () {
        _dispatch({
          type: 'COMMIT_NIBP'
        });
      }, 5000);
      return function () {
        return clearTimeout(timeout);
      };
    }, [state.nibp.inflating]);

    // Facilitator sounds and the patient's voice play whether or not the clock is running
    // (gating them on isRunning once silenced charge, shock and speech before START). The only thing to avoid is replaying a stale one when a screen first loads
    // the session (the first value it sees may be minutes old); after that, every new one
    // plays, whatever the two devices' clocks say.
    var seenSoundRef = useRef(false);
    var seenSpeechRef = useRef(false);
    var lastSoundRef = useRef(0);
    useEffect(function () {
      if (state.soundEffect && state.soundEffect.timestamp > lastSoundRef.current) {
        lastSoundRef.current = state.soundEffect.timestamp;
        var first = !seenSoundRef.current;
        seenSoundRef.current = true;
        if (first && Date.now() - state.soundEffect.timestamp > 8000) return;
        if (isAudioRouted(state) && audioCtxRef.current) {
          playMedicalSound(state.soundEffect.type);
        }
      }
    }, [state.soundEffect, isMonitorMode, state.audioOutput]);

    // The device's built-in voice, for typed words and any phrase without a recorded clip. Its
    // loudness is the device's own: the page cannot raise it.
    var speakAloud = function speakAloud(text) {
      if (!text || !('speechSynthesis' in window)) return;
      stopVoiceClip();
      window.speechSynthesis.cancel();
      if (window.speechSynthesis.paused) window.speechSynthesis.resume();
      var utterance = new SpeechSynthesisUtterance(text);
      utterance.volume = Math.min(1, volumeOf(stateRef.current));
      if (utterance.volume <= 0) return;
      var voices = window.speechSynthesis.getVoices();
      if (voices.length > 0) {
        var enVoice = voices.find(function (v) {
          return v.lang && v.lang.toLowerCase().startsWith('en-gb');
        }) || voices.find(function (v) {
          return v.lang && v.lang.toLowerCase().startsWith('en');
        });
        utterance.voice = enVoice || voices[0];
      }
      window.speechSynthesis.speak(utterance);
    };
    // Recorded voice clips (voices/<voice>/<phrase>.mp3) play through the same boosted output as
    // the alarms, so they are much louder than the built-in voice. Each is fetched the first time
    // it is used and kept decoded for the rest of the session. A new phrase cuts off the last one.
    var voiceBuffersRef = useRef({});
    var voiceSourceRef = useRef(null);
    var stopVoiceClip = function stopVoiceClip() {
      try {
        if (voiceSourceRef.current) voiceSourceRef.current.stop();
      } catch (e) {}
      voiceSourceRef.current = null;
    };
    var playVoiceClip = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(clip) {
        var ctx, buffer, res, bytes, src;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              ctx = audioCtxRef.current;
              if (!audioBlocked(ctx)) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return resumeAudio();
            case 1:
              buffer = voiceBuffersRef.current[clip];
              if (buffer) {
                _context.n = 6;
                break;
              }
              _context.n = 2;
              return fetch("voices/".concat(clip, ".mp3"));
            case 2:
              res = _context.v;
              if (res.ok) {
                _context.n = 3;
                break;
              }
              throw new Error("voice clip ".concat(clip, ": ").concat(res.status));
            case 3:
              _context.n = 4;
              return res.arrayBuffer();
            case 4:
              bytes = _context.v;
              _context.n = 5;
              return new Promise(function (ok, fail) {
                var p = ctx.decodeAudioData(bytes, ok, fail);
                if (p && p["catch"]) p["catch"](fail);
              });
            case 5:
              buffer = _context.v;
              voiceBuffersRef.current[clip] = buffer;
            case 6:
              stopVoiceClip();
              try {
                window.speechSynthesis && window.speechSynthesis.cancel();
              } catch (e) {}
              src = ctx.createBufferSource();
              src.buffer = buffer;
              src.connect(soundOut(ctx));
              src.start();
              voiceSourceRef.current = src;
              src.onended = function () {
                if (voiceSourceRef.current === src) voiceSourceRef.current = null;
              };
            case 7:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function playVoiceClip(_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    // Volume: set on the controller (state.volume); the patient screens get it inside the synced
    // defib object (see engine-sync.js). 0 is silent, 1 normal, 1.5 the most.
    var volumeOf = function volumeOf(st) {
      var v = isMonitorMode ? st.defib && st.defib.volume : st.volume;
      return Number.isFinite(v) ? Math.max(0, Math.min(1.5, v)) : 1;
    };
    var currentVolume = volumeOf(state);
    useEffect(function () {
      setSimVolume(audioCtxRef.current, currentVolume);
    }, [currentVolume, audioCtxState]);
    var lastSpeechRef = useRef(0);
    useEffect(function () {
      if (state.speech && state.speech.timestamp > lastSpeechRef.current) {
        lastSpeechRef.current = state.speech.timestamp;
        var first = !seenSpeechRef.current;
        seenSpeechRef.current = true;
        if (first && Date.now() - state.speech.timestamp > 8000) return;
        if (!isAudioRouted(state)) return;
        var clip = state.speech.clip;
        if (clip && window.VOICE_CLIPS && window.VOICE_CLIPS.includes(clip) && audioCtxRef.current) {
          playVoiceClip(clip)["catch"](function () {
            return speakAloud(state.speech.text);
          });
        } else speakAloud(state.speech.text);
      }
    }, [state.speech, isMonitorMode, state.audioOutput]);
    var _addLogEntry = function _addLogEntry(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
      var flagged = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var deviation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      return _dispatch({
        type: 'ADD_LOG',
        payload: {
          msg: msg,
          type: type,
          flagged: flagged,
          deviation: deviation
        }
      });
    };
    var applyIntervention = function applyIntervention(key) {
      // Always read live state — this function is invoked from async paths (Firebase command listener)
      // where the closed-over `state` would be stale.
      var cur = stateRef.current;
      var scenario = cur.scenario;
      // Declared here, before its first use: the overdose and adenosine branches below read it,
      // and as a later `const` (compiled to `var` by Babel) it was undefined there, so 1 mg IV
      // adrenaline in cardiac arrest was flagged as an overdose in a patient with a pulse.
      var isArrest = RG.inArrest(cur.rhythm); // Registry. The old literal also required bpSys<10 AND wrongly included VT-with-a-pulse.
      // These two used to be silent no-ops, so a mistyped key or a not-yet-loaded scenario made
      // the button look broken with no explanation anywhere.
      if (!scenario) {
        console.warn("applyIntervention('".concat(key, "') ignored: no scenario is loaded."));
        _dispatch({
          type: 'SET_NOTIFICATION',
          payload: {
            msg: 'No scenario loaded — load a scenario first.',
            type: 'danger',
            id: Date.now()
          }
        });
        return;
      }
      if (key === 'ToggleETCO2') {
        _dispatch({
          type: 'TOGGLE_ETCO2'
        });
        _addLogEntry(cur.etco2Enabled ? 'ETCO2 Disconnected' : 'ETCO2 Connected', 'action');
        return;
      }
      var action = INTERVENTIONS[key];
      if (!action) {
        console.warn("Unknown intervention key '".concat(key, "' \u2014 no definition in INTERVENTIONS."));
        _addLogEntry("Unknown intervention '".concat(key, "' requested \u2014 nothing applied (check scenario data)."), 'warning', true);
        _dispatch({
          type: 'SET_NOTIFICATION',
          payload: {
            msg: "Unknown intervention: ".concat(key),
            type: 'danger',
            id: Date.now()
          }
        });
        return;
      }

      // PERMISSIVE GATING. Nothing is ever blocked. Unmet expectations are recorded as a flagged
      // deviation (amber log row, toolbar chip, debrief card) plus a brief non-blocking toast.
      // Performing RSI without pre-oxygenation is assessable behaviour worth RECORDING, not
      // preventing. Follows the existing non-blocking precedents (pacing without capture, shock
      // into a non-shockable rhythm).
      var missingLabels = _getUnmetExpectations(action, cur);
      if (missingLabels.length > 0) {
        var missingText = missingLabels.join(', ');
        _addLogEntry("".concat(action.label, " performed WITHOUT: ").concat(missingText), 'warning', true, {
          action: key,
          label: action.label,
          missing: missingLabels
        });
        _dispatch({
          type: 'SET_NOTIFICATION',
          payload: {
            msg: "".concat(action.label, " \u2014 missing ").concat(missingText, " (proceeding)"),
            type: 'warning',
            id: Date.now()
          }
        });
      }

      // POINT-OF-CARE CHECKS. These are INTERMITTENT: they publish the value
      // as it is right now, timestamped, and then stop tracking. Repeating the check takes a
      // fresh sample. (A continuous sensor, by contrast, keeps updating.) Fully permissive: a
      // VBG with no IV access has already raised its amber flag above and still proceeds.
      if (key === 'CheckGlucose' || key === 'CheckVBG') {
        var v = cur.vitals || {};
        var clock = new Date().toLocaleTimeString('en-GB', {
          hour: '2-digit',
          minute: '2-digit'
        });
        if (key === 'CheckGlucose') {
          _dispatch({
            type: 'RECORD_POC',
            payload: {
              key: 'bm',
              value: Number.isFinite(v.bm) ? v.bm : null,
              at: cur.time,
              clock: clock
            }
          });
          _addLogEntry("Capillary glucose ".concat(Number.isFinite(v.bm) ? v.bm.toFixed(1) : '--', " mmol/L (POC, ").concat(clock, ")."), 'action');
        } else {
          // The VBG reports pH and potassium at the moment the sample was taken: the same
          // gas the monitor's VBG button gives (window.liveVbg).
          var gas = window.liveVbg ? window.liveVbg(cur.scenario, v, cur.activeInterventions, cur.time) : {
            pH: v.ph,
            K: v.k
          };
          _dispatch({
            type: 'RECORD_POC',
            payload: {
              key: 'vbg',
              value: Number.isFinite(gas.pH) ? gas.pH : null,
              value2: Number.isFinite(gas.K) ? gas.K : null,
              at: cur.time,
              clock: clock
            }
          });
          _addLogEntry("VBG: pH ".concat(Number.isFinite(gas.pH) ? gas.pH.toFixed(2) : '--', ", K+ ").concat(Number.isFinite(gas.K) ? gas.K.toFixed(1) : '--', " mmol/L (POC, ").concat(clock, ")."), 'action');
        }
        // Execution deliberately CONTINUES into the normal intervention path below, so the
        // check is counted and logged by exactly the same machinery as everything else.
      }
      var isActive = cur.activeInterventions.has(key);
      if (action.type === 'continuous' && isActive) {
        // Deliberate toggle-off. The button shows an explicit ACTIVE state and a tooltip saying
        // a second press stops it, so removal cannot be mistaken for a repeat dose.
        // Monitoring keys take the sensor-aware removal, which expands the
        // 'Obs' shorthand. Without this the PROCEDURES card and the chip could disagree about
        // what is attached; both now resolve through getSensors() over the same set.
        if (key === 'Obs' || STANDARD_SENSOR_KEYS.indexOf(key) !== -1) _dispatch({
          type: 'DETACH_SENSOR',
          payload: key
        });else _dispatch({
          type: 'REMOVE_INTERVENTION',
          payload: key
        });
        // Stopping compressions clears the flag as well as starting the drug's offset tail.
        if (action.effect && action.effect.cpr === true && cur.cprInProgress) _dispatch({
          type: 'TOGGLE_CPR',
          payload: false
        });
        // Taken off before START: its effect never reaches the patient.
        dropPendingEffects(key);
        _addLogEntry("".concat(action.label, " removed."), 'action');
        _dispatch({
          type: 'SET_NOTIFICATION',
          payload: {
            msg: "".concat(action.label, " STOPPED (second press toggles off)"),
            type: 'info',
            id: Date.now()
          }
        });
        return;
      }
      var isPaedsWf = scenario.ageRange === 'Paediatric' && scenario.wetflag;
      var logMsg = action.log;
      if (key === 'Fluids') {
        logMsg = isPaedsWf ? "Fluid Bolus (".concat(scenario.wetflag.fluids, "ml) administered.") : "Fluid Bolus (500ml) administered.";
      }
      if (isPaedsWf) {
        if (key === 'AdrenalineIV') logMsg = "IV Adrenaline (".concat(scenario.wetflag.adrenaline, "mcg) administered.");
        if (key === 'Lorazepam') logMsg = "IV Lorazepam (".concat(scenario.wetflag.lorazepam, "mg) administered.");
        if (key === 'InsulinDextrose') logMsg = "Glucose (".concat(scenario.wetflag.glucose, "ml) administered.");
      }
      // PART 5 — PAEDIATRIC DOSING NOTES (RCUK 2025). These are COACHING LINES, never blocks:
      // the facilitator always gets to give the drug. The dose actually logged is the
      // paediatric one where the weight or age is known.
      if (scenario.ageRange === 'Paediatric' || ageBandOf(scenario) !== 'adult') {
        var wt = scenario.wetflag && scenario.wetflag.weight;
        var paeds = paediatricDoseNotes(key, scenario, {
          count: ((cur.interventionCounts || {})[key] || 0) + 1,
          inArrest: RG.inArrest(cur.rhythm)
        });
        if (paeds.log) logMsg = paeds.log;
        paeds.notes.forEach(function (n) {
          return _addLogEntry(n, 'info');
        });
        if (key === 'KetamineIM') _addLogEntry("Paediatric IM ketamine for procedural sedation: 4 mg/kg".concat(wt ? " = ".concat(Math.round(4 * wt), " mg") : '', ". Peak dissociation ~5 min, 15-30 min of usable sedation \u2014 do NOT stack doses while waiting."), 'info');
        if (key === 'Sux') _addLogEntry('Suxamethonium in a child: bradycardia is common (and marked with a second dose) — have atropine drawn up.', 'warning');
      }
      // RCUK anaphylaxis (adults and children): no improvement in breathing or circulation
      // despite TWO doses of IM adrenaline is refractory anaphylaxis.
      if (key === 'AdrenalineIM' && ((cur.interventionCounts || {})[key] || 0) + 1 === 2) {
        _addLogEntry('Second IM adrenaline dose. If breathing or circulation problems persist, this is REFRACTORY anaphylaxis (RCUK): seek expert help early, give a rapid IV fluid bolus and start a low-dose IV adrenaline infusion; give IM adrenaline every 5 min until the infusion is running.', 'warning');
      }
      // Instant (no-pk) effects are applied to the BASE physiology, exactly as before. Anything
      // carrying a `pk` envelope is instead pushed onto activeDrugs and composed every tick.
      // BEFORE START (see notStarted): the intervention is recorded exactly as usual, but every
      // effect on the patient goes through fx(), which holds it until START and then runs it on
      // the state as it is then. While the clock runs (or is paused) fx() runs it at once, on
      // the same `cur` as before, so nothing changes for a running scenario. A pk drug needs no
      // holding: its envelope is timed on state.time, which does not move before START.
      var defer = _notStarted(cur);
      var announce = false;
      var heldEffects = [];
      var fx = function fx(fn) {
        if (defer) heldEffects.push(fn);else fn(cur);
      };
      var newActive = new Set(cur.activeInterventions);
      var newCounts = _objectSpread({}, cur.interventionCounts);
      var count = (newCounts[key] || 0) + 1;
      if (action.duration && !cur.activeDurations[key]) _dispatch({
        type: 'START_INTERVENTION_TIMER',
        payload: {
          key: key,
          duration: action.duration
        }
      });

      // --- PK ENVELOPE (A1) ------------------------------------------------------------------
      // Push an entry instead of mutating vitals. Repeat dosing pushes another entry, which is
      // naturally cumulative, but each drug's total contribution is capped at pk.maxDoses.
      //
      // WAVE 4a adds three things to the entry:
      //   * PART 2B volume responsiveness  -> `dose` multiplier for fluid/blood/albumin
      //   * PART 5  paediatric scaling      -> per-field magnitude scale by age band
      //   * PART 2C cumulative-dose ceiling -> an explicit, VISIBLE max-dose warning
      var entryOpts = {};
      var volumeNote = null;
      if (VOLUME_KEYS.indexOf(key) !== -1) {
        var vr = fluidResponsiveness(scenario);
        entryOpts.dose = vr.factor;
        volumeNote = vr;
      }
      var pScale = paediatricFieldScale(scenario);
      if (pScale) entryOpts.fieldScale = pScale;
      // A heart-rate drug works differently in different rhythms: atropine barely moves a
      // broad escape rhythm, isoprenaline does (RHYTHMS.drugHrResponse).
      var hrResponse = RG.drugHrResponse(key, cur.rhythm);
      if (hrResponse !== 1) {
        entryOpts.fieldScale = _objectSpread(_objectSpread({}, entryOpts.fieldScale || {}), {}, {
          HR: (entryOpts.fieldScale && entryOpts.fieldScale.HR || 1) * hrResponse
        });
        if (hrResponse < 0.5) _addLogEntry("".concat(action.label, " in ").concat(RG.labelFor(cur.rhythm), ": little rate response expected \u2014 the block/escape is below the level this drug acts on. Consider isoprenaline or adrenaline infusion as a bridge, and pacing."), 'info');
      }
      // Paediatric note: suxamethonium bradycardia is common in children, and marked with a
      // second dose. The adult entry has no haemodynamic effect at all.
      if (key === 'Sux' && pScale) {
        entryOpts.effect = _objectSpread(_objectSpread({}, action.effect || {}), {}, {
          HR: -20
        });
      }
      var drugEntry = buildDrugEntry(key, action, cur.time, entryOpts.dose === undefined ? 1 : entryOpts.dose, entryOpts);
      if (drugEntry) {
        _dispatch({
          type: 'ADD_ACTIVE_DRUG',
          payload: drugEntry
        });
        // PART 2C: the ceiling used to be reached SILENTLY. It is counted from every dose
        // given (interventionCounts), not only from the entries that happen to still be
        // pharmacologically live, and it is announced in the log (flagged, so it reaches the
        // debrief) AND as a toast. Nothing is ever blocked.
        var givenBefore = (cur.interventionCounts || {})[key] || 0;
        var cum = action.cumulative || null;
        var capDoses = cum ? Math.max(1, Math.round(Number(cum.max) / Number(cum.perDose))) : drugEntry.maxDoses;
        var effectiveCap = Math.min(drugEntry.maxDoses, capDoses);
        if (givenBefore + 1 >= effectiveCap) {
          var totalText = cum ? " (cumulative ".concat(((givenBefore + 1) * Number(cum.perDose)).toLocaleString('en-GB'), " ").concat(cum.unit, " of a ").concat(Number(cum.max).toLocaleString('en-GB'), " ").concat(cum.unit, " maximum)") : '';
          // Reaching the maximum is correct practice and is only noted; going PAST it is the
          // deviation that is flagged (and reaches the debrief).
          var pastCap = givenBefore + 1 > effectiveCap;
          if (pastCap) {
            _addLogEntry("".concat(action.label, ": MAXIMUM MODELLED DOSE ALREADY REACHED").concat(totalText, " \u2014 this dose adds NO further response.").concat(cum ? ' ' + cum.message : ''), 'warning', true, {
              action: key,
              label: action.label,
              missing: ['within maximum cumulative dose']
            });
            _dispatch({
              type: 'SET_NOTIFICATION',
              payload: {
                msg: "".concat(action.label, " \u2014 MAX DOSE reached (no further effect)"),
                type: 'warning',
                id: Date.now()
              }
            });
          } else {
            _addLogEntry("".concat(action.label, ": maximum modelled dose reached").concat(totalText, ".").concat(cum ? ' ' + cum.message : ' Further doses will add no further response.'), 'info');
          }
        } else if (!drugEntry.sustained && drugEntry.onset > 15) {
          _addLogEntry("".concat(action.label, ": onset ~").concat(drugEntry.onset, "s, peak ~").concat(Math.round(drugEntry.peak / 60 * 10) / 10, " min").concat(drugEntry.offset > drugEntry.peak ? ", wears off by ~".concat(Math.round(drugEntry.offset / 60), " min") : '', "."), 'info');
        }
        if (volumeNote) {
          // The facilitator is told WHY the bolus did or did not work, because that is the
          // teaching point the sim was previously unable to make.
          if (volumeNote.factor >= 1) _addLogEntry("".concat(action.label, ": this patient is FLUID RESPONSIVE (").concat(volumeNote.source, ") \u2014 expect a meaningful rise in blood pressure over the next few minutes."), 'info');else if (volumeNote.factor <= 0.35) _addLogEntry("".concat(action.label, ": this patient is NOT fluid responsive (").concat(volumeNote.source, ") \u2014 the pressure will barely move. Reassess: does this shock need a pressor, an inotrope, blood or the operating theatre?"), 'warning', true, {
            action: key,
            label: action.label,
            missing: ['fluid responsiveness']
          });else _addLogEntry("".concat(action.label, ": partial fluid responsiveness (").concat(volumeNote.source, ") \u2014 reassess after the bolus."), 'info');
          if (volumeNote.overload) {
            // Fluid into a wet patient worsens gas exchange. Time-limited via the envelope.
            var oedema = buildDrugEntry(key + 'Overload', action, cur.time, 1, {
              effect: {
                SpO2: -5,
                RR: 3
              },
              pk: {
                onset: 60,
                peak: 600,
                offset: 3600,
                maxDoses: 3
              }
            });
            if (oedema) _dispatch({
              type: 'ADD_ACTIVE_DRUG',
              payload: oedema
            });
            _addLogEntry("".concat(action.label, " given to a fluid-overloaded patient \u2014 oxygenation is WORSENING. Consider stopping fluid, sitting them up, CPAP/NIV, GTN and diuresis."), 'danger', true, {
              action: key,
              label: action.label,
              missing: ['fluid responsiveness']
            });
          }
        }
        // A declared REBOUND phase is pushed as a second, delayed entry (late
        // hypoglycaemia after insulin/dextrose being the archetype). pkFactor already
        // returns 0 for an entry whose startTime is in the future, so nothing else changes.
        if (action.rebound) {
          var rb = buildDrugEntry(key + 'Rebound', action, cur.time + (Number(action.rebound.delay) || 0), 1, {
            effect: action.rebound.effect,
            pk: action.rebound.pk || action.pk
          });
          if (rb) {
            _dispatch({
              type: 'ADD_ACTIVE_DRUG',
              payload: rb
            });
            if (action.rebound.log) _addLogEntry(action.rebound.log, 'info');
          }
        }
      }
      // Put on by the team after set-up kit came off: it is theirs now (scenario.setupKit, setUpIntervention).
      if (action.type === 'continuous' && Array.isArray(scenario.setupKit) && scenario.setupKit.indexOf(key) !== -1) _dispatch({
        type: 'UPDATE_SCENARIO',
        payload: _objectSpread(_objectSpread({}, scenario), {}, {
          setupKit: scenario.setupKit.filter(function (k) {
            return k !== key;
          })
        })
      });
      if (action.type === 'continuous') {
        newActive.add(key);
        _addLogEntry(logMsg, 'action');
      } else {
        newCounts[key] = count;
        _addLogEntry(logMsg, 'action');
      }
      // WAVE 9 / ROOT FIX: a DELTA, not the whole set/counts object. Two interventions applied
      // in the same tick (two clicks in one batch, a batch helper, or the Firebase command
      // listener firing twice) used to lose everything but the last one, because both payloads
      // were built from the same pre-commit `stateRef.current`.
      if (action.type === 'continuous') _dispatch({
        type: 'UPDATE_INTERVENTION_STATE',
        payload: {
          add: [key],
          inc: []
        }
      });else _dispatch({
        type: 'UPDATE_INTERVENTION_STATE',
        payload: {
          add: [],
          inc: [key]
        }
      });

      // A point-of-care test is taken, not given.
      var isPocCheck = SENSOR_DEFS.some(function (d) {
        return d.kind === 'poc' && d.key === key;
      });
      _dispatch({
        type: 'SET_NOTIFICATION',
        payload: {
          msg: action.label + (isPocCheck ? " checked" : " Administered"),
          type: 'success',
          id: Date.now()
        }
      });

      // Keyword credit (OBJECTIVE_TRIGGERS) only for objectives with no authored components:
      // an authored objective is scored from its components or by the facilitator, so a keyword
      // in its wording ("...from anaphylaxis") can no longer tick it for the wrong drug.
      keywordObjectivesFor(scenario, key).forEach(function (obj) {
        return _dispatch({
          type: 'COMPLETE_OBJECTIVE',
          payload: obj
        });
      });
      if (scenario.stabilisers && scenario.stabilisers.includes(key)) {
        announce = true;
        fx(function () {
          _dispatch({
            type: 'TRIGGER_IMPROVE'
          });
          _addLogEntry("Patient condition IMPROVING", "success");
        });
      }
      // ---- E10: THE DEAD KEY. This test used to be `key === 'Adrenaline' && count >= 2`, and
      // there is NO intervention called 'Adrenaline' in INTERVENTIONS — the key is
      // 'AdrenalineIM' (or AdrenalineIV/AdrenalinePush/AdrenalineInfusion). Anaphylaxis
      // scenarios therefore NEVER improved, no matter how correctly they were treated.
      // It also only matched scenarios whose TITLE contained "Anaphylaxis", so an
      // anaphylaxis presenting as "Peanut reaction" was excluded.
      var ANAPHYLAXIS_ADRENALINE = ['AdrenalineIM', 'AdrenalineIV', 'AdrenalinePush', 'AdrenalineInfusion'];
      var looksAnaphylactic = isAnaphylaxisScenario(scenario);
      if (looksAnaphylactic && ANAPHYLAXIS_ADRENALINE.indexOf(key) !== -1) {
        // RCUK: improvement after the FIRST correct dose of IM adrenaline is the expected
        // clinical course, and the 5-minute repeat is the next step if it does not come.
        announce = true;
        fx(function () {
          _dispatch({
            type: 'TRIGGER_IMPROVE'
          });
          _addLogEntry("".concat(action.label, " in anaphylaxis \u2014 patient condition IMPROVING. Reassess at 5 minutes and repeat IM adrenaline if the improvement is incomplete."), 'success');
        });
        if (key === 'AdrenalineIM' && count === 1) _addLogEntry('After initial treatment (RCUK 2021): mast cell tryptase, first sample as soon as feasible without delaying treatment, second 1-2 h (no later than 4 h) after onset. Observation: fast-track discharge after 2 h only if one dose worked within 5-10 min, symptoms fully resolved and the patient has auto-injectors and supervision; at least 6 h after resolution if 2 doses were needed; at least 12 h for more than 2 doses, severe asthma or respiratory compromise, or a previous biphasic reaction.', 'info');
        if (key === 'AdrenalineInfusion') _addLogEntry('RCUK peripheral low-dose adrenaline infusion (refractory anaphylaxis): 1 mg in 100 ml 0.9% sodium chloride via a dedicated line, start at 0.5-1 ml/kg/h and titrate to response; continuous ECG and SpO2, BP at least every 5 min. Not on the same side as a BP cuff.', 'info');
      }
      // RCUK Emergency treatment of anaphylaxis (2021): steroids are not advised routinely;
      // antihistamines are third-line and have no role in A, B or C problems.
      if (looksAnaphylactic && (key === 'Hydrocortisone' || key === 'Dexamethasone' || key === 'Chlorphenamine')) {
        var adrenalineGiven = ANAPHYLAXIS_ADRENALINE.some(function (k) {
          return ((cur.interventionCounts || {})[k] || 0) > 0 || cur.activeInterventions && cur.activeInterventions.has(k);
        });
        if (!adrenalineGiven) _addLogEntry("".concat(action.label, " given before any adrenaline in anaphylaxis. Adrenaline is the first-line treatment; ").concat(key === 'Chlorphenamine' ? 'antihistamines' : 'steroids', " must never be given in preference to it (RCUK 2021)."), 'warning', true, {
          action: 'AdrenalineIM',
          label: 'IM Adrenaline',
          missing: ['adrenaline before other drugs']
        });
        _addLogEntry(key === 'Chlorphenamine' ? 'Antihistamines are third-line in anaphylaxis (RCUK 2021) and do not treat airway, breathing or circulation problems. After stabilisation, for skin symptoms, a non-sedating oral antihistamine (e.g. cetirizine) is preferred to chlorphenamine; IV chlorphenamine can cause hypotension if given rapidly.' : 'Corticosteroids are no longer advised for the routine emergency treatment of anaphylaxis (RCUK 2021). Consider them only after initial resuscitation, for refractory reactions or ongoing asthma or shock, and never in preference to adrenaline or fluids.', 'info');
      }
      // --- PARALYSIS (roc vs sux genuinely differ) ---
      // Folded into the pk envelope. The blockade window is derived from the SAME
      // activeDrugs entry pushed above (onset = pk.onset, end = pk.offset or paralysis.duration),
      // so there is exactly one timer. SET_PARALYSIS is only used here as an immediate mirror for
      // the UI/sync before the next tick recomputes it from activeDrugs.
      if (action.paralysis || action.effect.paralysed) {
        var pz = action.paralysis || {
          onset: action.pk && action.pk.onset || 60,
          duration: (action.pk && action.pk.offset || 2760) - (action.pk && action.pk.onset || 60)
        };
        fx(function (now) {
          return _dispatch({
            type: 'SET_PARALYSIS',
            payload: {
              active: true,
              agent: key,
              startTime: now.time,
              onset: pz.onset,
              duration: pz.duration
            }
          });
        });
        if (key === 'Sux') _addLogEntry('Fasciculations observed after suxamethonium.', 'info');
        var ventilated = isVentilated(cur.activeInterventions);
        _addLogEntry("".concat(action.label, ": paralysis in ~").concat(pz.onset, "s, lasting ~").concat(Math.round(pz.duration / 60), " min.").concat(ventilated ? '' : ' Patient is NOT being ventilated — expect apnoea and desaturation.'), ventilated ? 'info' : 'warning', !ventilated);
      }
      if (action.effect.reverseParalysis) {
        // REVERSAL IS NOT INSTANT. Sugammadex restores a train-of-four ratio > 0.9 in
        // roughly 1.5-3 min (longer for a deep block), and the whole teaching point is that
        // you keep ventilating while you wait. Previously the blockade vanished on the
        // administering tick, which taught the opposite.
        var rev = action.reversalOver || {
          onset: action.pk && action.pk.onset || 60,
          full: action.pk && action.pk.peak || 180
        };
        var onsetS = Math.max(0, Number(rev.onset) || 0);
        var fullS = Math.max(onsetS + 1, Number(rev.full) || onsetS + 120);
        _addLogEntry("".concat(action.label, ": reversal is NOT instant \u2014 first twitches at ~").concat(onsetS, "s, full reversal by ~").concat(Math.round(fullS / 60 * 10) / 10, " min. KEEP VENTILATING until spontaneous effort is adequate."), 'warning', true, {
          action: key,
          label: action.label,
          missing: ['continued ventilation during reversal']
        });
        var finishReversal = function finishReversal() {
          var now = stateRef.current;
          if (!now || now.isFinished) return;
          _dispatch({
            type: 'REVERSE_PARALYSIS_DRUGS'
          });
          _dispatch({
            type: 'SET_PARALYSIS',
            payload: {
              active: false
            }
          });
          if (!isVentilated(now.activeInterventions)) {
            _dispatch({
              type: 'UPDATE_VITALS',
              payload: _objectSpread(_objectSpread({}, now.baseVitals), {}, {
                rr: Math.max(now.baseVitals.rr || 0, 10)
              })
            });
          }
          _addLogEntry("".concat(action.label, ": neuromuscular blockade now fully reversed \u2014 spontaneous ventilation returning."), 'success');
        };
        // Partial reversal first (weak, inadequate effort), then full reversal. Both on the
        // sim clock, so a pause holds them and a newly loaded scenario cancels them.
        simTimeout(function () {
          var now = stateRef.current;
          if (!now || now.isFinished) return;
          _addLogEntry("".concat(action.label, ": first twitches returning \u2014 respiratory effort is present but INADEQUATE. Continue to support ventilation."), 'info');
        }, onsetS);
        simTimeout(finishReversal, fullS);
      }

      // --- B3: effect.cpr. Wave 3 owns the full CPR/cprInProgress/defib work; this is the safe,
      // non-overlapping part: an intervention that declares itself to be chest compressions sets
      // the flag, and removing it clears the flag (see REMOVE_INTERVENTION above for the drug
      // tail). That immediately activates the already-written arrest ETCO2 physiology, the CPR
      // waveform artefact and the ROSC bonus, all of which were dead code. Wave 3 should extend
      // this (compression quality, pauses, metronome) rather than re-adding the flag.
      if (action.effect.cpr === true && !cur.cprInProgress) {
        // C5 (Wave 3): route through the shared helper so the cycle timer resets, the
        // assessor gets the CPR indicator and the coaching line is consistent wherever
        // compressions are started from.
        _toggleCPR(true, action.label || 'intervention');
      }

      // --- AIRWAY / RSI: clinically honest oxygenation instead of a jump to SpO2 99 ---
      // The facilitator keeps full control of the outcome: a successful RSI secures the airway
      // (RSI counts as ventilation), while FailedIntubation/CICO hand the airway back and let the
      // existing hypoxia model desaturate the paralysed patient. Nothing here is random.
      var rsiDesaturates = false;
      if (key === 'RSI') {
        var preoxKeys = ['Preoxygenation', 'ApnoeicOxygenation', 'Oxygen', 'Bagging', 'NIV', 'CPAP'];
        var preoxed = preoxKeys.some(function (k) {
          return cur.activeInterventions.has(k);
        });
        if (preoxed) {
          _addLogEntry('Apnoeic period begins — pre-oxygenated, so saturations are protected for now.', 'info');
        } else {
          // No reservoir: desaturation starts immediately. The tick-level hypoxia model carries
          // it on from here if the airway is not secured promptly.
          rsiDesaturates = true;
          // Flagged only: the permissive gating above has already recorded the missing
          // pre-oxygenation as this RSI's one sequence deviation.
          _addLogEntry('Apnoeic period begins with NO pre-oxygenation — desaturating.', 'warning', true);
        }
        if (!cur.activeInterventions.has('ApnoeicOxygenation')) {
          _addLogEntry('No apnoeic oxygenation in place — safe apnoea time is shorter.', 'info');
        }
        _addLogEntry('Confirm the tube: ETCO2 waveform, chest rise, bilateral air entry. Declare failed intubation early if the view is poor.', 'info');
      }
      if (key === 'TubeConfirm' && !cur.etco2Enabled) {
        _dispatch({
          type: 'TOGGLE_ETCO2'
        });
        _addLogEntry('ETCO2 connected for tube confirmation.', 'action');
      }
      if (key === 'FailedIntubation' || key === 'CICO') {
        // The airway is NOT secured: stop treating RSI as ventilation so a paralysed patient
        // desaturates until the facilitator rescues with SGA, BVM or FONA.
        if (cur.activeInterventions.has('RSI')) _dispatch({
          type: 'REMOVE_INTERVENTION',
          payload: 'RSI'
        });
        _addLogEntry(key === 'CICO' ? 'CICO: airway NOT secured. Oxygenate by any means, then front-of-neck access.' : 'Airway NOT secured after failed attempt. Oxygenate between attempts.', 'danger', true);
      }

      // =====================================================================================
      // PART 2A — 1 mg IV ADRENALINE IN A PERFUSING PATIENT: "yes, and model the consequence".
      // Never blocked. A prominent FLAGGED DEVIATION is raised, and the realistic consequence
      // (marked hypertension and tachycardia, occasionally arrhythmia) is simulated through
      // the pk envelope so it is time-limited and wears off, exactly like the real thing.
      // =====================================================================================
      if (key === 'AdrenalineIV' && !isArrest) {
        _addLogEntry("\u26A0 1 mg IV ADRENALINE GIVEN TO A PATIENT WITH A PULSE (".concat(RG.labelFor(cur.rhythm), "). This is a TEN-FOLD to TWENTY-FOLD overdose for a perfusing patient \u2014 the peri-arrest / anaphylaxis doses are 50-100 mcg IV (push-dose) or 500 mcg IM. Expect a hypertensive, tachycardic response; watch for arrhythmia, pulmonary oedema and myocardial ischaemia."), 'danger', true, {
          action: key,
          label: action.label,
          missing: ['a pulseless rhythm (1 mg IV is an ARREST dose)']
        });
        _dispatch({
          type: 'SET_NOTIFICATION',
          payload: {
            msg: '1mg IV adrenaline in a PERFUSING patient — flagged. Modelling the consequence.',
            type: 'danger',
            id: Date.now()
          }
        });
        // The consequence rides on its own entry so it is additive to the drug's normal
        // effect, independently capped, and fully gone within ~10 min.
        var overdose = buildDrugEntry('AdrenalineIVOverdose', action, cur.time, 1, {
          effect: {
            HR: 35,
            BP: 55
          },
          pk: {
            onset: 15,
            peak: 75,
            plateau: 180,
            offset: 600,
            maxDoses: 3
          }
        });
        if (overdose) _dispatch({
          type: 'ADD_ACTIVE_DRUG',
          payload: overdose
        });
        _dispatch({
          type: 'TRIGGER_SPEAK',
          payload: 'My heart is pounding — my chest feels tight and my head is thumping.'
        });
      }

      // =====================================================================================
      // ADENOSINE: a SCRIPTED, TRANSIENT sequence, not a jump to HR 80.
      // Half-life is under 10 s. What the team must see is: flush → a few seconds of AV block
      // or sinus pause (the frightening bit) → either conversion to sinus at ~15 s or the SVT
      // simply carrying on, in which case you escalate 6 → 12 → 18 mg (RCUK). Everything is resolved
      // inside ~45 s, and nothing lingers (pk offset 40 s).
      // =====================================================================================
      if (action.avBlock && !isArrest) {
        var ab = action.avBlock;
        var doseNo = count; // RCUK: 6 mg, then 12 mg, then 18 mg
        // A child's dose is weight-based (RCUK 2025): 0.1-0.2 mg/kg, then 0.3 mg/kg (max
        // 12-18 mg); a neonate's 150 mcg/kg rising to 300 mcg/kg.
        var paedsDose = paediatricAdenosineDose(scenario, doseNo);
        var doseMg = doseNo === 1 ? 6 : doseNo === 2 ? 12 : 18;
        var doseText = paedsDose || "".concat(doseMg, " mg");
        _addLogEntry("Adenosine ".concat(doseText, " given as a RAPID push into a large proximal vein with an immediate saline flush. Warn the patient: flushing, chest tightness and a feeling of doom are expected and last seconds."), 'action');
        _dispatch({
          type: 'TRIGGER_SPEAK',
          payload: 'Oh — that feels horrible. My chest is tight. I feel like something awful is happening.'
        });
        _addLogEntry("Transient AV block / sinus pause for ~".concat(ab.pause || 8, "s \u2014 run a rhythm strip NOW: this is the diagnostic window."), 'warning');
        var chances = Array.isArray(ab.chanceByDose) ? ab.chanceByDose : [0.55, 0.75, 0.8];
        var chance = chances[Math.min(doseNo, chances.length) - 1];
        simTimeout(function () {
          var now = stateRef.current;
          if (!now || now.isFinished) return;
          if (RG.inArrest(now.rhythm)) return;
          applyDrugConversion(now, 'Adenosine', "Adenosine ".concat(doseText), {
            chance: chance
          });
        }, Math.max(1, Number(ab.convertAt) || 12));
      }

      // Everything below changes the patient, so before START it waits for START (fx).
      // `now` is the state it runs on: `cur` while the clock runs, the state at START otherwise.
      fx(function (now) {
        var isArrest = RG.inArrest(now.rhythm);
        var newVitals = _objectSpread({}, now.baseVitals);
        if (rsiDesaturates) newVitals.spO2 = clamp(newVitals.spO2 - 6, 0, 100);
        // All three changeRhythm modes are handled now. 'sync' and 'chance' were silently
        // ignored before Wave 3, which is why the Cardioversion intervention did nothing and
        // Adrenaline IV / Amiodarone changed no rhythm in any scenario.
        if (action.avBlock) {
          // handled above as a timed sequence — do NOT convert on the administering tick.
        } else if (action.effect.changeRhythm === 'defib') {
          applyShockOutcome(now, {
            energy: now.defib && now.defib.energy || undefined,
            sync: false,
            source: 'facilitator'
          });
        } else if (action.effect.changeRhythm === 'sync') {
          _applyCardioversion(now, {
            energy: now.defib && now.defib.energy || undefined,
            source: 'facilitator'
          });
        } else if (action.effect.changeRhythm === 'chance') {
          // A drug cannot change the rhythm before it has reached the heart: the roll (and any
          // shock bonus) happens at the drug's onset on the sim clock, and only if the rhythm
          // it was given for is still the rhythm then.
          var _onsetS = drugEntry && Number(drugEntry.onset) > 0 ? Number(drugEntry.onset) : 0;
          if (_onsetS > 0) {
            var givenIn = RG.canonical(now.rhythm);
            simTimeout(function () {
              var now = stateRef.current;
              if (!now || now.isFinished || RG.canonical(now.rhythm) !== givenIn) return;
              applyDrugConversion(now, key, action.label || key);
            }, _onsetS);
          } else applyDrugConversion(now, key, action.label || key);
        } else if (typeof action.effect.changeRhythm === 'string' && RG.isKnown(action.effect.changeRhythm)) {
          // A scenario/intervention may name a specific target rhythm outright.
          changeRhythm(action.effect.changeRhythm, 'intervention', {
            agent: action.label || key
          });
        }

        // ARREST PHYSIOLOGY. During a pulseless rhythm there is no cardiac output, so drugs cannot
        // drive HR/BP — and, critically, SpO2 must NOT imply perfusion that does not exist (BVM in
        // asystole used to display SpO2 25%). Previously HR/BP/RR were silently discarded while
        // SpO2/GCS were still applied; now the suppression is total and it is LOGGED.
        if (isArrest) {
          var e = action.effect || {};
          var suppressed = ['HR', 'BP', 'RR', 'SpO2'].filter(function (f) {
            return e[f] !== undefined && e[f] !== null;
          });
          if (suppressed.length) {
            _addLogEntry("".concat(action.label, " given during arrest (").concat(now.rhythm, ") \u2014 ").concat(suppressed.join('/'), " unchanged: a pulseless patient has no perfusion to measure. ETCO2 is the marker to watch."), 'warning');
          }
        }
        // Any numeric field the pk envelope owns is deliberately NOT applied here — otherwise the
        // drug would land twice (once instantly, once through the envelope). `pkOwned` is what
        // preserves today's instant behaviour for everything WITHOUT a pk block.
        var pkOwned = function pkOwned(field) {
          return !!(drugEntry && drugEntry.effect && drugEntry.effect[field] !== undefined);
        };
        var paceCaptured = false;
        if (!isArrest) {
          if (action.effect.HR) {
            // 'reset' is retained for backwards compatibility with saved/custom interventions.
            // Adenosine no longer uses it: an instant jump to HR 80 in one tick was exactly
            // the behaviour that hid the pause-then-conversion teaching point (see the
            // adenosine sequence below).
            if (action.effect.HR === 'reset') newVitals.hr = 80;else if (action.effect.HR === 'pace') {
              // Pacing only captures if output exceeds threshold
              var pacer = now.remotePacerState || {
                rate: 0,
                output: 0
              };
              if (pacer.output >= now.pacingThreshold && pacer.rate > 0) {
                newVitals.hr = pacer.rate;
                paceCaptured = true;
                // Electrical capture without mechanical capture is worthless, and a
                // rate number alone taught trainees not to feel for a pulse.
                _addLogEntry("Pacing: ELECTRICAL capture at ".concat(pacer.output, "mA, rate ").concat(pacer.rate, ". Now CONFIRM MECHANICAL CAPTURE \u2014 feel a central pulse / check the SpO2 trace. Give analgesia and sedation: pacing hurts."), 'success');
              } else {
                _addLogEntry("Pacing: no capture (output ".concat(pacer.output, "mA < threshold ").concat(now.pacingThreshold, "mA) \u2014 increase the output until every pacing spike is followed by a QRS AND a pulse."), 'warning');
              }
            } else if (!pkOwned('HR')) newVitals.hr = clampVital('hr', newVitals.hr + action.effect.HR);
          }
          // Perfusion only improves if the pacer actually captured.
          if (key === 'Pacing' && !paceCaptured) {/* no haemodynamic benefit without capture */} else if (action.effect.BP && !pkOwned('BP')) {
            newVitals.bpSys = clampVital('bpSys', newVitals.bpSys + action.effect.BP);
            newVitals.bpDia = clampVital('bpDia', newVitals.bpDia + action.effect.BP * 0.6);
          }
          if (action.effect.RR) {
            if (action.effect.RR === 'vent') {
              newVitals.rr = VENTILATOR_RATE;
            } else if (typeof action.effect.RR === 'number' && !pkOwned('RR')) {
              newVitals.rr = clampVital('rr', newVitals.rr + action.effect.RR);
            }
          }
        }
        // SpO2 is inside the arrest guard too: a pulse oximeter cannot read a saturation without
        // a pulse, so BVM in asystole must not display 25%.
        if (!isArrest && action.effect.SpO2 && !pkOwned('SpO2')) newVitals.spO2 = clampVital('spO2', newVitals.spO2 + action.effect.SpO2);
        if (action.effect.gcs) {
          if (typeof action.effect.gcs === 'string') {
            if (action.effect.gcs === 'sedated') newVitals.gcs = 3;
          } else if (!pkOwned('gcs')) {
            newVitals.gcs = clampVital('gcs', newVitals.gcs + action.effect.gcs);
          }
        }

        // --- GROUP B: BM / Temp / pH were authored on 12 interventions and read by NOTHING, so
        // Dextrose could not change the glucose reading, Warming/Cooling could not change the
        // temperature and SodiumBicarb's pH was dropped on the floor. They are now first-class
        // modelled vitals. Anything with a pk block ramps through the envelope; anything without
        // one still lands instantly, which keeps the schema backwards compatible.
        if (action.effect.BM !== undefined && action.effect.BM !== null && !pkOwned('BM')) newVitals.bm = clampVital('bm', newVitals.bm + Number(action.effect.BM));
        if (action.effect.Temp !== undefined && action.effect.Temp !== null && !pkOwned('Temp')) newVitals.temp = clampVital('temp', newVitals.temp + Number(action.effect.Temp));
        if (action.effect.pH !== undefined && action.effect.pH !== null && !pkOwned('pH')) newVitals.ph = clampVital('ph', (Number.isFinite(newVitals.ph) ? newVitals.ph : 7.4) + Number(action.effect.pH));
        var updatedScenario = _objectSpread({}, now.scenario);
        var updateNeeded = false;
        // A new object, never an edit: chestXray is shared with the scenario library, so editing it in
        // place would start the next run of this scenario with the lung already re-expanded. The
        // report and image can be on the scenario or in its generated investigations, so clear both.
        if (key === 'Needle' || key === 'FingerThoracostomy') {
          var inv = updatedScenario.investigations || {};
          var ptx = function ptx(c) {
            return !!(c && /pneumothorax/i.test(String(c.findings || '')) && !/\bno (evidence of )?pneumothorax/i.test(String(c.findings || '')));
          };
          if (ptx(updatedScenario.chestXray) || ptx(inv.chestXray)) {
            var clear = {
              findings: 'Lung re-expanded after decompression.',
              image: null,
              findingId: null
            };
            updatedScenario.chestXray = _objectSpread(_objectSpread({}, updatedScenario.chestXray || {}), clear);
            if (inv.chestXray) updatedScenario.investigations = _objectSpread(_objectSpread({}, inv), {}, {
              chestXray: _objectSpread(_objectSpread({}, inv.chestXray), clear)
            });
            // A pneumothorax the facilitator chose is decompressed the same way, and is
            // then no longer "their" result (data/investigations.js setResult).
            if (updatedScenario.invChanged && updatedScenario.invChanged['X-ray']) {
              updatedScenario.invChanged = Object.assign({}, updatedScenario.invChanged);
              updatedScenario.invDefaults = Object.assign({}, updatedScenario.invDefaults || {});
              delete updatedScenario.invChanged['X-ray'];
              delete updatedScenario.invDefaults['X-ray'];
            }
            updateNeeded = true;
          }
        }
        if (updateNeeded) _dispatch({
          type: 'UPDATE_SCENARIO',
          payload: updatedScenario
        });
        // Decompressing the chest fixes the ventilator's injected tension pneumothorax.
        if (['Needle', 'FingerThoracostomy', 'SeldingerDrain', 'SurgicalDrain'].indexOf(key) !== -1 && now.vent && (now.vent.probs || []).indexOf('ptx') !== -1) {
          _dispatch({
            type: 'SET_VENT_CONFIG',
            payload: {
              probs: now.vent.probs.filter(function (id) {
                return id !== 'ptx';
              })
            }
          });
          _addLogEntry('Ventilator problem fixed: tension pneumothorax decompressed.', 'system');
        }
        // Bronchoscopy clears the ventilator's injected mucus plug.
        if (key === 'Bronchoscopy' && now.vent && (now.vent.probs || []).indexOf('plug') !== -1) {
          _dispatch({
            type: 'SET_VENT_CONFIG',
            payload: {
              probs: now.vent.probs.filter(function (id) {
                return id !== 'plug';
              })
            }
          });
          _addLogEntry('Ventilator problem fixed: mucus plug cleared by bronchoscopy.', 'system');
        }
        // Pulling the tube back corrects the ventilator's injected endobronchial tube.
        if (key === 'TubeWithdraw' && now.vent && (now.vent.probs || []).indexOf('endo') !== -1) {
          _dispatch({
            type: 'SET_VENT_CONFIG',
            payload: {
              probs: now.vent.probs.filter(function (id) {
                return id !== 'endo';
              })
            }
          });
          _addLogEntry('Ventilator problem fixed: endobronchial tube pulled back.', 'system');
        }
        // Dantrolene in a malignant hyperthermia crisis (CO2 production raised on the ventilator's
        // lungs): CO2 production returns to normal, so the ETCO2 falls over the next few minutes.
        if (key === 'Dantrolene' && now.vent && now.vent.lung && Number(now.vent.lung.m) > 100) {
          _dispatch({
            type: 'SET_VENT_CONFIG',
            payload: {
              lung: {
                m: null
              }
            }
          });
          _addLogEntry('Ventilator lungs: CO2 production back to normal after dantrolene.', 'system');
        }
        // WAVE 9 / ROOT FIX (same class): send only the fields this intervention actually
        // CHANGED. The payload is merged onto the LIVE baseVitals by the reducer, so a whole
        // snapshot-derived object here meant two instant-effect interventions in one tick
        // overwrote each other's vitals. A field-level diff composes instead.
        var vitalsDelta = {};
        Object.keys(newVitals).forEach(function (f) {
          if (newVitals[f] !== now.baseVitals[f]) vitalsDelta[f] = newVitals[f];
        });
        // Still dispatched unconditionally (an empty delta simply recomposes the displayed
        // vitals from the live base + the drug envelope, exactly as before).
        _dispatch({
          type: 'UPDATE_VITALS',
          payload: vitalsDelta
        });
        if (action.type === 'continuous' && REVERSIBLE_INSTANT.indexOf(key) !== -1) {
          var deltas = {};
          Object.keys(vitalsDelta).forEach(function (f) {
            var d = Number(vitalsDelta[f]) - Number(now.baseVitals[f]);
            if (Number.isFinite(d) && d !== 0) deltas[f] = d;
          });
          // `held`: vitals already typed by hand BEFORE this intervention went on (its effect
          // overrode them, so removal may take it off); a value typed afterwards is left alone.
          var held = {};
          Object.keys(deltas).forEach(function (f) {
            if (now.manualHold && now.manualHold[f]) held[f] = true;
          });
          instantDeltasRef.current[key] = {
            runId: now.runId,
            arrest: isArrest,
            deltas: deltas,
            held: held
          };
        }
      });
      if (!defer) return;
      // Held until START, in order. Said so once, when it would have changed the patient
      // (attaching a monitor or recording IV access has nothing to wait for).
      var e0 = action.effect || {};
      var acts = announce || !!drugEntry || rsiDesaturates || Object.keys(e0).some(function (k) {
        return k !== 'cpr' && e0[k] !== undefined && e0[k] !== null && e0[k] !== 0 && e0[k] !== false;
      });
      deferUntilStart(key, acts ? action.label || key : null, function (now) {
        return heldEffects.forEach(function (fn) {
          return fn(now);
        });
      });
      if (acts) _addLogEntry("".concat(action.label, " recorded before START: the patient is not live yet, so it starts acting when START is pressed."), 'info');
    };
    var applyInterventionRef = useRef(applyIntervention);
    useEffect(function () {
      applyInterventionRef.current = applyIntervention;
    }, [applyIntervention]);
    useEffect(function () {
      var db = window.db;
      if (!db || !sessionID || isMonitorMode) return;
      var cmdRef = db.ref("sessions/".concat(sessionID, "/command"));
      var handleCmd = function handleCmd(snap) {
        var val = snap.val();
        if (val && val.ts > lastCmdRef.current) {
          lastCmdRef.current = val.ts;
          if (val.type === 'START_NIBP') _dispatch({
            type: 'START_NIBP'
          });
          if (val.type === 'STOP_NIBP') _dispatch({
            type: 'STOP_NIBP'
          });
          if (val.type === 'TOGGLE_NIBP_MODE') _dispatch({
            type: 'TOGGLE_NIBP_MODE'
          });
          if (val.type === 'TRIGGER_ACTION') {
            if (applyInterventionRef.current) {
              applyInterventionRef.current(val.payload);
            }
          }
        }
      };
      var handleCommandReadError = function handleCommandReadError(error) {
        console.error('Firebase command listener failed:', error);
        _dispatch({
          type: 'SET_SYNC_STATUS',
          payload: {
            state: 'error',
            message: "Live-session command read failed: ".concat(error.message || 'unknown error')
          }
        });
      };
      cmdRef.on('value', handleCmd, handleCommandReadError);
      return function () {
        return cmdRef.off('value', handleCmd);
      };
    }, [isMonitorMode, sessionID]);

    // Facilitator obs changes are logged in words, with the value before and after, because
    // the debrief's obs graph lists them as "what changed". BP is one entry (120/75 → 90/52).
    var OBS_LABELS = {
      hr: 'HR',
      spO2: 'SpO2',
      rr: 'RR',
      temp: 'Temp',
      bm: 'Glucose',
      etco2: 'ETCO2',
      gcs: 'GCS',
      ph: 'pH',
      k: 'K+',
      pupils: 'Pupils',
      bpSys: 'BP systolic',
      bpDia: 'BP diastolic'
    };
    var obsText = function obsText(key, v) {
      var n = Number(v);
      if (!Number.isFinite(n)) return String(v);
      return key === 'ph' ? n.toFixed(2) : key === 'temp' || key === 'bm' || key === 'etco2' || key === 'k' ? n.toFixed(1) : String(Math.round(n));
    };
    var describeObs = function describeObs(targets, from) {
      var parts = [];
      var t = _objectSpread({}, targets);
      if (t.bpSys !== undefined && t.bpDia !== undefined) {
        parts.push("BP ".concat(obsText('bpSys', from.bpSys), "/").concat(obsText('bpDia', from.bpDia), " \u2192 ").concat(obsText('bpSys', t.bpSys), "/").concat(obsText('bpDia', t.bpDia)));
        delete t.bpSys;
        delete t.bpDia;
      }
      Object.keys(t).forEach(function (k) {
        return parts.push("".concat(OBS_LABELS[k] || k, " ").concat(obsText(k, from[k]), " \u2192 ").concat(obsText(k, t[k])));
      });
      return parts.join(', ');
    };
    var fmtDuration = function fmtDuration(s) {
      return s >= 60 && s % 60 === 0 ? "".concat(s / 60, " min") : "".concat(s, " s");
    };
    // AN RR TYPED WITH A VENTILATOR IN THE ROOM. The ventilator measures the rate the patient
    // breathes, and while it breathes for the patient the monitor shows that measured rate. A typed
    // RR used to stop at the monitor (held there), so the ventilator and the monitor disagreed. Now,
    // when the patient breathes for themselves, it also becomes the patient's own rate on the
    // ventilator (the Spontaneous rate lung adjustment), and the monitor hands RR back to the
    // ventilator once the ventilator measures about that rate (or after 30 s of ventilating, when a
    // mandatory rate above it wins). A sedated or paralysed patient has no own rate: the typed RR
    // just holds, as before ("Release to ventilator" hands it back).
    var rrHandoffRef = useRef(null);
    var ventOwnRate = function ventOwnRate(cur, rr) {
      var VE = window.VENT_ENGINE,
        VP = window.VENT_PROFILES;
      var n = Number(rr);
      if (!VE || !VP || !Number.isFinite(n) || cur.ventLink === false) return null;
      var d = VP.LUNG_ADJ.e;
      if (n < d.min || n > d.max) return null;
      // A ventilator taken away stays in the mirror for a minute: it is not the patient's any more.
      // (A ventilator on the patient screens closes with the panel; a separate tablet stays.)
      var recent = Object.values(cur.ventMirror || {}).some(function (m) {
        return m && !m.embedded && Number(m.ts) > Date.now() - 25000;
      });
      if (!VE.driverFor(cur) && !(cur.ventPanelOpen && Object.keys(cur.ventMirror || {}).length) && !recent) return null;
      var cfg = VE.configFor(cur);
      if (cfg.breathing === false || VP.lungFor(cfg).sedated) return null;
      return Math.round(n);
    };
    var manualUpdateVitals = function manualUpdateVitals(targets) {
      var cur = stateRef.current;
      var from = _objectSpread({}, cur.vitals);
      Object.keys(targets).forEach(function (key) {
        return _dispatch({
          type: 'MANUAL_VITAL_UPDATE',
          payload: {
            key: key,
            value: targets[key]
          }
        });
      });
      _addLogEntry("Obs changed: ".concat(describeObs(targets, from)), 'manual');
      var own = targets.rr !== undefined ? ventOwnRate(cur, targets.rr) : null;
      if (own !== null) {
        _dispatch({
          type: 'SET_VENT_CONFIG',
          payload: {
            lung: {
              e: own
            }
          }
        });
        rrHandoffRef.current = {
          value: own,
          at: Date.now()
        };
        _addLogEntry("Ventilator: the patient now breathes at ".concat(own, "/min. The monitor's RR follows the ventilator again once it measures it."), 'system');
      } else if (targets.rr !== undefined) rrHandoffRef.current = null;
    };
    useEffect(function () {
      var h = rrHandoffRef.current;
      if (isMonitorMode || !h) return;
      var cur = stateRef.current;
      if (!(cur.manualHold && cur.manualHold.rr)) {
        rrHandoffRef.current = null;
        return;
      }
      var d = window.VENT_ENGINE && window.VENT_ENGINE.driverFor(cur);
      if (!d || !d.phys) return;
      if (!h.driving) h.driving = Date.now();
      if (Math.abs(Number(d.phys.rr) - h.value) <= 2 || Date.now() - Math.max(h.at, h.driving) > 30000) {
        rrHandoffRef.current = null;
        _dispatch({
          type: 'RELEASE_MANUAL_HOLD',
          payload: ['rr']
        });
      }
    }, [isMonitorMode, state.ventMirror]);
    var manualUpdateVital = function manualUpdateVital(key, value) {
      return manualUpdateVitals(_defineProperty({}, key, value));
    };

    // =====================================================================================
    // THE SINGLE CHOKE POINT FOR EVERY RHYTHM TRANSITION.
    // Before Wave 3 the rhythm could change from FIVE places (manual grid, ARREST menu, ROSC
    // menu, shock outcome, nextCycle) with three of them logging nothing, and UPDATE_RHYTHM
    // itself logging nothing at all. Nothing may dispatch UPDATE_RHYTHM directly any more.
    //
    // `cause` is a short machine-ish token ('defibrillation', 'manual selection', 'arrest',
    // 'ROSC', 'drug', 'cardioversion', 'deterioration', 'rhythm check', 'refibrillation').
    // `meta` carries the clinical detail the assessor needs: energy, synchronised, drug label.
    //
    // B4 LEAK BARRIER: the announcement is written to state.rhythmEvent / state.lastConversion,
    // which are ASSESSOR-LOCAL and deliberately excluded from the Firebase payload. It is NOT
    // written to `notification`, because `notification` is synced and rendered on the student
    // monitor — announcing "VF → Sinus (defibrillation)" there would hand the team the answer.
    // =====================================================================================
    var conversionSeqRef = useRef(0);
    var changeRhythm = function changeRhythm(next) {
      var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unspecified';
      var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var cur = stateRef.current;
      var from = RG.canonical(cur.rhythm);
      var to = RG.canonical(next);
      if (!RG.isKnown(next)) {
        _addLogEntry("Rhythm \"".concat(next, "\" is not in the rhythm registry \u2014 showing ").concat(RG.labelFor(to), " instead. This is a content bug, please report it."), 'warning', true);
      }

      // Human-readable detail: energy + synchronisation for shocks, agent for drugs.
      var bits = [];
      if (cause) bits.push(cause);
      if (Number.isFinite(Number(meta.energy))) bits.push("".concat(Math.round(Number(meta.energy)), "J"));
      if (meta.sync === true) bits.push('synchronised');
      if (meta.sync === false && meta.energy) bits.push('unsynchronised');
      if (meta.agent) bits.push(meta.agent);
      if (meta.note) bits.push(meta.note);
      var detail = bits.join(', ');
      conversionSeqRef.current += 1;
      var eventId = "".concat(Date.now(), "-").concat(conversionSeqRef.current);

      // One consistent, assessor-readable line for EVERY transition, converted or not.
      if (from === to) {
        _addLogEntry("Rhythm: ".concat(RG.labelFor(from), " unchanged (").concat(detail || cause, ")"), 'info');
      } else {
        _addLogEntry("Rhythm: ".concat(RG.labelFor(from), " \u2192 ").concat(RG.labelFor(to), " (").concat(detail || cause, ")"), 'action', false);
      }
      _dispatch({
        type: 'UPDATE_RHYTHM',
        payload: to,
        cause: cause,
        detail: detail,
        eventId: eventId
      });
      return to;
    };

    // Cosmetic: auto-expire the assessor toast so it behaves like the existing notification toast.
    useEffect(function () {
      if (!coreState.rhythmEvent) return;
      var id = setTimeout(function () {
        return dispatchCore({
          type: 'CLEAR_RHYTHM_EVENT',
          currentState: stateRef.current
        });
      }, 6000);
      return function () {
        return clearTimeout(id);
      };
    }, [coreState.rhythmEvent && coreState.rhythmEvent.id]);

    // A flash is a momentary cue. 'red' after Worse or an arrest used to stay set, and the
    // monitor's .flash-red animates for as long as it is set (and reads it as SHOCK DELIVERED),
    // so the room pulsed red indefinitely. Whatever set it, it clears itself after 1.5 s, unless
    // it has changed or a new scenario has loaded meanwhile.
    useEffect(function () {
      if (isMonitorMode || !state.flash) return;
      var f = state.flash,
        run = state.runId;
      var id = setTimeout(function () {
        var now = stateRef.current;
        if (now && now.flash === f && now.runId === run) _dispatch({
          type: 'SET_FLASH',
          payload: null
        });
      }, 1500);
      return function () {
        return clearTimeout(id);
      };
    }, [state.flash, isMonitorMode]);
    var arrestVitals = function arrestVitals(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        hr: 0,
        bpSys: 0,
        bpDia: 0,
        spO2: 0,
        rr: 0,
        gcs: 3,
        pupils: 'Dilated',
        etco2: 1.5
      });
    };
    // The vitals an arrest / ROSC write owns outright. Writing them releases the
    // facilitator's manual hold, because the transition itself establishes a new baseline.
    var RESET_HOLD_KEYS = ['hr', 'bpSys', 'bpDia', 'spO2', 'rr', 'gcs', 'pupils', 'etco2'];
    var triggerArrest = function triggerArrest() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'VF';
      var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'arrest';
      var cur = stateRef.current;
      _dispatch({
        type: 'STOP_TREND'
      });
      _dispatch({
        type: 'UPDATE_VITALS',
        payload: arrestVitals(cur.baseVitals),
        releaseManual: RESET_HOLD_KEYS
      });
      changeRhythm(type, cause);
      _addLogEntry("CARDIAC ARREST - ".concat(RG.labelFor(type)), 'manual', true);
      _dispatch({
        type: 'SET_FLASH',
        payload: 'red'
      });
    };
    var triggerROSC = function triggerROSC() {
      var _cur$scenario$patient2, _cur$scenario3;
      var rhythm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Sinus Rhythm';
      var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ROSC';
      var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var cur = stateRef.current;
      // ---- WAVE 5 / ITEM 7: ROSC IS NEVER A SILENT NO-OP -----------------------------------
      // "Return of spontaneous circulation" only means something if there was no spontaneous
      // circulation to start with. Clicking a ROSC rhythm when the patient already has an
      // organised rhythm with output used to overwrite the obs with post-ROSC values (GCS 8,
      // SpO2 94, a rhythm-band HR) on a patient who was never pulseless — and when the chosen
      // rhythm equalled the current one it produced no visible change at all, so the
      // facilitator could not tell whether the click had registered.
      // Permissive philosophy: nothing is blocked. The rhythm change is still performed, the
      // post-arrest obs are NOT forced onto a patient who never arrested, and the reason is
      // both logged and shown as a toast.
      if (!RG.isPulseless(cur.rhythm)) {
        var target0 = RG.canonical(rhythm);
        var same = target0 === RG.canonical(cur.rhythm);
        _addLogEntry(same ? "ROSC selected (".concat(RG.labelFor(target0), ") but the patient is not in a pulseless rhythm and is already in ").concat(RG.labelFor(target0), " \u2014 nothing to restore, so the obs were left exactly as they are. Use ARREST first, or the rhythm grid / vitals tiles to change anything.") : "ROSC selected (".concat(RG.labelFor(target0), ") but the patient is not in a pulseless rhythm (currently ").concat(RG.labelFor(cur.rhythm), ") \u2014 treated as a plain rhythm change. Post-arrest obs were NOT applied, because there was no arrest to recover from."), 'warning', true);
        _dispatch({
          type: 'SET_NOTIFICATION',
          payload: {
            msg: same ? "Already in ".concat(RG.labelFor(target0), " \u2014 no change made") : "Not in arrest \u2014 rhythm changed to ".concat(RG.labelFor(target0), " only"),
            type: 'warning',
            id: Date.now()
          }
        });
        if (!same) changeRhythm(target0, "".concat(cause, " (patient not in arrest \u2014 rhythm change only)"), meta);
        return;
      }
      var age = (_cur$scenario$patient2 = (_cur$scenario3 = cur.scenario) === null || _cur$scenario3 === void 0 ? void 0 : _cur$scenario3.patientAge) !== null && _cur$scenario$patient2 !== void 0 ? _cur$scenario$patient2 : 40;
      var base = window.getBaseVitals ? window.getBaseVitals(age) : {
        hr: 80,
        rr: 16,
        bpSys: 110,
        bpDia: 70
      };
      var newEtco2 = Math.round((5.0 + Math.random() * 1.5) * 10) / 10;
      // ROSC is no longer always exactly Sinus Rhythm. Honour the rhythm we were given,
      // and let the registry supply its rate band so a ROSC into AF is not shown at 80/min.
      var target = RG.canonical(rhythm);
      var band = hrBandFor(target, age);
      var hr = band ? getRandomInt(band[0], band[1]) : base.hr;
      var roscOwn = roscOwnVitals(cur.scenario);
      _dispatch({
        type: 'STOP_TREND'
      });
      _dispatch({
        type: 'UPDATE_VITALS',
        payload: _objectSpread(_objectSpread({}, cur.baseVitals), {}, {
          hr: hr,
          bpSys: base.bpSys,
          bpDia: base.bpDia,
          spO2: 94,
          rr: base.rr,
          gcs: 8,
          pupils: 3,
          etco2: newEtco2
        }, roscOwn),
        releaseManual: RESET_HOLD_KEYS
      });
      changeRhythm(target, cause, meta);
      if (cur.scenario) {
        var updatedScenario = _objectSpread(_objectSpread({}, cur.scenario), {}, {
          deterioration: _objectSpread(_objectSpread({}, cur.scenario.deterioration || {}), {}, {
            active: false
          })
        });
        _dispatch({
          type: 'UPDATE_SCENARIO',
          payload: updatedScenario
        });
      }
      _addLogEntry("ROSC achieved (".concat(RG.labelFor(target), "). Post-ROSC care: 12-lead, targeted oxygenation, treat the cause."), 'success', true);
      _dispatch({
        type: 'SET_FLASH',
        payload: 'green'
      });
    };
    // THE SIMULATION ENGINE: DEFIBRILLATION AND PACING (data/engine-defib.js).
    var _window$__EngineDefib = window.__EngineDefib.useDefib({
        RESET_HOLD_KEYS: RESET_HOLD_KEYS,
        addLogEntry: _addLogEntry,
        arrestVitals: arrestVitals,
        changeRhythm: changeRhythm,
        clearSimTimer: clearSimTimer,
        deferUntilStart: deferUntilStart,
        dispatch: _dispatch,
        isMonitorMode: isMonitorMode,
        notStarted: _notStarted,
        simTimeout: simTimeout,
        state: state,
        stateRef: stateRef,
        triggerArrest: triggerArrest,
        triggerROSC: triggerROSC
      }),
      _analyseRhythm = _window$__EngineDefib.analyseRhythm,
      _applyCardioversion = _window$__EngineDefib.applyCardioversion,
      applyDrugConversion = _window$__EngineDefib.applyDrugConversion,
      applyShockOutcome = _window$__EngineDefib.applyShockOutcome,
      defibWeight = _window$__EngineDefib.defibWeight,
      _deliverShock = _window$__EngineDefib.deliverShock,
      drugOnBoard = _window$__EngineDefib.drugOnBoard,
      goToDefibStep = _window$__EngineDefib.goToDefibStep,
      _initCharge = _window$__EngineDefib.initCharge,
      recommendedShockEnergy = _window$__EngineDefib.recommendedShockEnergy,
      refibTimerRef = _window$__EngineDefib.refibTimerRef,
      _setDefibEnergy = _window$__EngineDefib.setDefibEnergy,
      _setDefibMode = _window$__EngineDefib.setDefibMode,
      setQueuedRhythm = _window$__EngineDefib.setQueuedRhythm,
      shockPolicy = _window$__EngineDefib.shockPolicy,
      stepsRunning = _window$__EngineDefib.stepsRunning,
      _toggleCPR = _window$__EngineDefib.toggleCPR,
      toggleDefibSync = _window$__EngineDefib.toggleDefibSync;

    // `opts.image` is an image key from data/investigations.js; `opts.hideReport` shows the image
    // without its written report (the team interprets it). With no custom text, the monitor
    // shows the scenario's own result and its image.
    var revealInvestigation = function revealInvestigation(type) {
      var customText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      _dispatch({
        type: 'SET_LOADING_INVESTIGATION',
        payload: type
      });
      setTimeout(function () {
        var cur = stateRef.current;
        var finalCustomText = customText;

        // VBG: if no manual override supplied, derive from current state
        // The AUTHORED VBG is authoritative for the baseline. It used to be bypassed
        // whenever scenario.vbg was null (113/254 scenarios, because enrichScenario wrote
        // the resolved default block to scenario.investigations.vbg but left the top-level
        // scenario.vbg null), so generateVbg('normal') supplied its VENOUS default of
        // pO2 5.0 over an authored arterial pO2 of 12.
        // PRECEDENCE, deliberately: authored scenario.vbg  >  enriched
        // scenario.investigations.vbg  >  generateVbg('normal'). calculateDynamicVbg then
        // applies TIME/TREATMENT DELTAS on top of that baseline; every key it does not
        // model (pO2, Na, Ca) is carried through from the authored block untouched.
        if ((type === 'VBG' || type === 'ABG') && !customText && cur.scenario && window.calculateDynamicVbg) {
          // window.liveVbg (data/generators.js) does exactly that, then reports the
          // patient's own modelled pH and K+ in the gas (they are not shown as obs). The ABG
          // is derived from the same gas (window.liveAbg).
          // Pass the structured object — monitor.js will detect and render the printout,
          // with what the analyser prints at the top: the sample type, when it was run, and
          // the inspired oxygen (the ventilator's setting when one is breathing for the
          // patient; room air when no oxygen is on; otherwise not entered).
          var vd = window.VENT_ENGINE && window.VENT_ENGINE.driverFor ? window.VENT_ENGINE.driverFor(cur) : null;
          var ventO2 = vd ? Number(vd.phys && vd.phys.fio2) || (Number(vd.o2) > 0 ? Number(vd.o2) / 100 : null) : null;
          var OXYGEN = ['Oxygen', 'Preoxygenation', 'ApnoeicOxygenation', 'Bagging', 'NIV', 'CPAP', 'RSI', 'i-gel'];
          var onOxygen = OXYGEN.some(function (k) {
            return cur.activeInterventions && cur.activeInterventions.has && cur.activeInterventions.has(k);
          });
          var sid = String(cur.scenario && (cur.scenario.id || cur.scenario.title || cur.scenario.patientName) || 'SIM');
          var h = 0;
          for (var i = 0; i < sid.length; i++) h = (h * 31 + sid.charCodeAt(i)) % 9000;
          var fio2 = ventO2 ? Math.min(1, Math.max(0.21, ventO2)) : onOxygen ? null : 0.21;
          // The ABG's pO2 needs an FiO2 even when none is printed: on oxygen without a
          // ventilator, take about 0.6 (a high-flow mask; NIV, CPAP and a bag are similar).
          // opts.normal (the controller's Normal button): a normal gas for this patient, with
          // the live oxygenation but none of the scenario's derangement.
          var normal = !!(opts && opts.normal);
          var gScen = normal ? Object.assign({}, cur.scenario, {
            vbg: window.generateVbg ? window.generateVbg('normal') : null
          }) : cur.scenario;
          var gVitals = normal ? Object.assign({}, cur.vitals, {
            ph: 7.4,
            k: 4.2,
            bm: cur.scenario.quickSim ? cur.vitals.bm : null
          }) : cur.vitals;
          var gAi = normal ? new Set() : cur.activeInterventions;
          var dynamic = type === 'ABG' ? window.liveAbg(gScen, gVitals, gAi, normal ? 0 : cur.time, fio2 || (onOxygen ? 0.6 : 0.21)) : window.liveVbg(gScen, gVitals, gAi, normal ? 0 : cur.time);
          finalCustomText = _objectSpread(_objectSpread({
            __vbg: true
          }, dynamic), {}, {
            sample: type === 'ABG' ? 'Arterial' : 'Venous',
            takenAt: Date.now(),
            temp: 37.0,
            // run at 37 °C, as an ED gas is unless the patient's temperature is entered
            fio2: fio2,
            patientId: 'SIM-' + String(1000 + h)
          });
        }
        _dispatch({
          type: 'REVEAL_INVESTIGATION',
          payload: type
        });
        _dispatch({
          type: 'TRIGGER_POPUP',
          payload: {
            type: type,
            customText: finalCustomText,
            image: opts && opts.image || null,
            hideReport: !!(opts && opts.hideReport),
            normal: !!(opts && opts.normal)
          }
        });
        _addLogEntry("".concat(type, " Result Available"), 'success');
      }, 100);
    };
    var clearInvestigation = function clearInvestigation() {
      _dispatch({
        type: 'CLEAR_POPUP'
      });
    };
    // 2-minute ALS cycle. Wired to a real button on the assessor's defib panel in Wave 3
    // (it previously existed but nothing could reach it).
    var nextCycle = function nextCycle() {
      var cur = stateRef.current;
      _dispatch({
        type: 'FAST_FORWARD',
        payload: 120
      });
      _dispatch({
        type: 'RESET_CYCLE_TIMER'
      });
      _addLogEntry('Rhythm check at 2 minutes (+2:00 fast forward)', 'system');
      if (cur.queuedRhythm) {
        var q = RG.canonical(cur.queuedRhythm);
        _dispatch({
          type: 'SET_QUEUED_RHYTHM',
          payload: null
        });
        if (RG.isPulseless(q)) {
          _dispatch({
            type: 'UPDATE_VITALS',
            payload: arrestVitals(cur.baseVitals)
          });
          changeRhythm(q, 'rhythm check (facilitator override)');
        } else {
          triggerROSC(q, 'rhythm check (facilitator override)');
        }
        return;
      }
      // A custom sequence decides the rhythm itself.
      if (!stepsRunning(cur)) nonShockableRhythmCheck(cur);
    };

    // PEA and asystole have no shock to convert them: ROSC comes from good CPR, adrenaline and
    // treating the cause, and it is found at a RHYTHM CHECK.
    //   'model': a chance at each check — small on its own, better with CPR running, and much
    //            better with adrenaline on board (given in the last few minutes).
    //   'auto':  deterministic — ROSC at the SECOND rhythm check after adrenaline, provided
    //            compressions are running. Without adrenaline it does not happen.
    //   fixed shock numbers and 'never': the facilitator decides (ROSC button / override).
    var nonShockableRhythmCheck = function nonShockableRhythmCheck(cur) {
      var rid = RG.canonical(cur.rhythm);
      if (!RG.isPulseless(rid) || RG.isShockable(rid)) return;
      var pol = shockPolicy(cur);
      var adrenaline = drugOnBoard(cur, 'AdrenalineIV');
      if (pol === 'auto') {
        if (!adrenaline) {
          _addLogEntry("Rhythm check: still ".concat(RG.labelFor(rid), ". Adrenaline 1 mg is due as soon as possible in a non-shockable rhythm."), 'warning');
          return;
        }
        var checks = (cur.defib && cur.defib.adrChecks || 0) + 1;
        _dispatch({
          type: 'SET_DEFIB_STATE',
          payload: {
            adrChecks: checks
          }
        });
        if (checks >= 2 && cur.cprInProgress) {
          triggerROSC(rid === 'PEA' ? 'Sinus Tachycardia' : 'Sinus Bradycardia', 'rhythm check', {
            agent: 'adrenaline and CPR'
          });
        } else {
          _addLogEntry("Rhythm check: still ".concat(RG.labelFor(rid)).concat(cur.cprInProgress ? '' : ' — and compressions are not running', ". Continue CPR, repeat adrenaline every 3-5 minutes, treat reversible causes."), 'info');
        }
        return;
      }
      if (pol !== 'model') return;
      var chance = 0.03 + (cur.cprInProgress ? 0.04 : 0) + (adrenaline ? 0.14 : 0);
      if (rid === 'PEA') chance *= 1.5;
      if (rid === 'Asystole') chance *= 0.5;
      if (Math.random() < chance) {
        triggerROSC(rid === 'PEA' ? 'Sinus Tachycardia' : 'Sinus Bradycardia', 'rhythm check', {
          agent: adrenaline ? 'adrenaline and CPR' : 'CPR'
        });
      } else {
        _addLogEntry("Rhythm check: still ".concat(RG.labelFor(rid), ".").concat(adrenaline ? '' : ' Adrenaline improves the chance of ROSC at the next check.'), 'info');
      }
    };
    // `clip` ('voice/phrase') names a recorded clip from the voice library (data/voices.js); the screen
    // that plays it falls back to the device's built-in voice if it has no such clip.
    var speak = function speak(text) {
      var clip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      _dispatch({
        type: 'TRIGGER_SPEAK',
        payload: text,
        clip: clip
      });
      _addLogEntry("Patient: \"".concat(text, "\""), 'manual');
    };
    var playSound = function playSound(type) {
      _dispatch({
        type: 'TRIGGER_SOUND',
        payload: type
      });
      _addLogEntry("Sound: ".concat(type), 'manual');
    };
    var startTrend = function startTrend(targets, durationSecs) {
      var from = _objectSpread({}, stateRef.current.vitals);
      _dispatch({
        type: 'START_TREND',
        payload: {
          targets: targets,
          duration: durationSecs
        }
      });
      _addLogEntry("Obs trend started: ".concat(describeObs(targets, from), " over ").concat(fmtDuration(durationSecs)), 'manual');
    };
    // Firebase may never have loaded (offline tablet, blocked CDN). Without this guard the student
    // monitor throws on every NIBP/action press instead of falling back to acting locally.
    var sendCommand = function sendCommand(payload) {
      if (!isMonitorMode || !sessionID || !window.db) return false;
      var safe = sanitizeForRealtimeDatabase(_objectSpread(_objectSpread({}, payload), {}, {
        ts: Date.now()
      }));
      if (!safe.value || safe.dropped.length) {
        var message = "Invalid monitor command was not sent: ".concat(safe.dropped.join(', ') || 'unknown field');
        console.error(message);
        _dispatch({
          type: 'SET_SYNC_STATUS',
          payload: {
            state: 'error',
            message: message
          }
        });
        return false;
      }
      try {
        window.db.ref("sessions/".concat(sessionID, "/command")).set(safe.value).then(function () {
          _dispatch({
            type: 'SET_SYNC_STATUS',
            payload: {
              state: 'connected',
              message: null,
              lastWriteAt: Date.now()
            }
          });
        })["catch"](function (e) {
          console.error('Command send failed:', e);
          _dispatch({
            type: 'SET_SYNC_STATUS',
            payload: {
              state: 'error',
              message: "Live-session command write failed: ".concat(e.message || 'unknown error')
            }
          });
        });
        return true;
      } catch (e) {
        console.error('Command send failed:', e);
        _dispatch({
          type: 'SET_SYNC_STATUS',
          payload: {
            state: 'error',
            message: "Live-session command write failed: ".concat(e.message || 'unknown error')
          }
        });
        return false;
      }
    };
    var triggerNIBP = function triggerNIBP() {
      if (!sendCommand({
        type: 'START_NIBP'
      })) _dispatch({
        type: 'START_NIBP'
      });
    };
    var stopNIBP = function stopNIBP() {
      if (!sendCommand({
        type: 'STOP_NIBP'
      })) _dispatch({
        type: 'STOP_NIBP'
      });
    };
    var toggleNIBPMode = function toggleNIBPMode() {
      if (!sendCommand({
        type: 'TOGGLE_NIBP_MODE'
      })) _dispatch({
        type: 'TOGGLE_NIBP_MODE'
      });
    };
    var triggerAction = function triggerAction(action) {
      if (!sendCommand({
        type: 'TRIGGER_ACTION',
        payload: action
      })) applyIntervention(action);
    };

    // If the context is (re-)suspended when the cuff starts, play once it has resumed rather
    // than dropping the sound (resume() is asynchronous).
    var playInflationSound = function playInflationSound() {
      var ctx0 = audioCtxRef.current;
      if (!ctx0) return;
      if (ctx0.state !== 'running') {
        resumeAudio().then(function () {
          if (ctx0.state === 'running' && stateRef.current.nibp.inflating) playInflationTone(ctx0);
        });
        return;
      }
      playInflationTone(ctx0);
    };
    var playInflationTone = function playInflationTone(ctx) {
      {
        var osc = ctx.createOscillator();
        var gain = ctx.createGain();
        osc.type = 'sawtooth';
        osc.frequency.setValueAtTime(60, ctx.currentTime);
        osc.frequency.linearRampToValueAtTime(50, ctx.currentTime + 5);
        var filter = ctx.createBiquadFilter();
        filter.type = 'lowpass';
        filter.frequency.value = 150;
        osc.connect(filter);
        filter.connect(gain);
        gain.connect(soundOut(ctx));
        gain.gain.setValueAtTime(0.3, ctx.currentTime);
        gain.gain.linearRampToValueAtTime(0.3, ctx.currentTime + 4.5);
        gain.gain.linearRampToValueAtTime(0, ctx.currentTime + 5);
        osc.start();
        osc.stop(ctx.currentTime + 5);
      }
    };
    var playMedicalSound = function playMedicalSound(type) {
      if (!audioCtxRef.current) return;
      var ctx = audioCtxRef.current;
      if (audioBlocked(ctx)) resumeAudio();
      var t = ctx.currentTime;

      // Volume check from the controller: the critical alarm tone, twice.
      if (type === 'VolumeTest') {
        [0, 0.35].forEach(function (d) {
          var osc = ctx.createOscillator();
          var gain = ctx.createGain();
          osc.frequency.value = 880;
          osc.connect(gain);
          gain.connect(soundOut(ctx));
          gain.gain.setValueAtTime(0.3, t + d);
          gain.gain.exponentialRampToValueAtTime(0.001, t + d + 0.3);
          osc.start(t + d);
          osc.stop(t + d + 0.3);
        });
        return;
      }
      if (type === 'charge') {
        var osc = ctx.createOscillator();
        var gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.setValueAtTime(400, t);
        osc.frequency.exponentialRampToValueAtTime(1200, t + 2.0);
        osc.connect(gain);
        gain.connect(soundOut(ctx));
        gain.gain.setValueAtTime(0, t);
        gain.gain.linearRampToValueAtTime(0.3, t + 0.1);
        gain.gain.setValueAtTime(0.3, t + 1.8);
        gain.gain.linearRampToValueAtTime(0, t + 2.0);
        osc.start(t);
        osc.stop(t + 2.0);
      } else if (type === 'shock') {
        var _osc = ctx.createOscillator();
        var _gain = ctx.createGain();
        var filter = ctx.createBiquadFilter();
        _osc.type = 'sawtooth';
        _osc.frequency.setValueAtTime(100, t);
        _osc.frequency.exponentialRampToValueAtTime(50, t + 0.2);
        filter.type = 'lowpass';
        filter.frequency.setValueAtTime(3000, t);
        filter.frequency.exponentialRampToValueAtTime(100, t + 0.2);
        _osc.connect(filter);
        filter.connect(_gain);
        _gain.connect(soundOut(ctx));
        _gain.gain.setValueAtTime(1.0, t);
        _gain.gain.exponentialRampToValueAtTime(0.01, t + 0.2);
        _osc.start(t);
        _osc.stop(t + 0.2);
      } else if (type === 'Wheeze') {
        var _osc2 = ctx.createOscillator();
        var _gain2 = ctx.createGain();
        var lfo = ctx.createOscillator();
        var lfoGain = ctx.createGain();
        _osc2.type = 'triangle';
        _osc2.frequency.value = 400;
        lfo.frequency.value = 0.4;
        lfoGain.gain.value = 150;
        lfo.connect(lfoGain);
        lfoGain.connect(_osc2.frequency);
        _osc2.connect(_gain2);
        _gain2.connect(soundOut(ctx));
        _gain2.gain.setValueAtTime(0, t);
        _gain2.gain.linearRampToValueAtTime(0.1, t + 1);
        _gain2.gain.linearRampToValueAtTime(0, t + 3);
        _osc2.start(t);
        lfo.start(t);
        _osc2.stop(t + 3);
        lfo.stop(t + 3);
      } else if (type === 'Stridor') {
        var osc1 = ctx.createOscillator();
        var osc2 = ctx.createOscillator();
        var _gain3 = ctx.createGain();
        osc1.frequency.value = 600;
        osc2.frequency.value = 620;
        osc1.type = 'sawtooth';
        osc2.type = 'sawtooth';
        osc1.connect(_gain3);
        osc2.connect(_gain3);
        _gain3.connect(soundOut(ctx));
        _gain3.gain.setValueAtTime(0, t);
        _gain3.gain.linearRampToValueAtTime(0.1, t + 0.5);
        _gain3.gain.linearRampToValueAtTime(0, t + 2);
        osc1.start(t);
        osc2.start(t);
        osc1.stop(t + 2);
        osc2.stop(t + 2);
      } else if (type === 'Vomit') {
        var bufferSize = ctx.sampleRate * 2;
        var buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
        var data = buffer.getChannelData(0);
        for (var i = 0; i < bufferSize; i++) {
          data[i] = Math.random() * 2 - 1;
        }
        var bufferSource = ctx.createBufferSource();
        bufferSource.buffer = buffer;
        var _filter = ctx.createBiquadFilter();
        _filter.type = 'lowpass';
        _filter.frequency.value = 300;
        var _gain4 = ctx.createGain();
        bufferSource.connect(_filter);
        _filter.connect(_gain4);
        _gain4.connect(soundOut(ctx));
        _gain4.gain.setValueAtTime(0, t);
        _gain4.gain.linearRampToValueAtTime(0.3, t + 0.2);
        _gain4.gain.exponentialRampToValueAtTime(0.01, t + 1.5);
        bufferSource.start(t);
        bufferSource.stop(t + 1.5);
      } else if (type === 'Snoring') {
        var _osc3 = ctx.createOscillator();
        var _gain5 = ctx.createGain();
        _osc3.type = 'sawtooth';
        _osc3.frequency.value = 40;
        _osc3.connect(_gain5);
        _gain5.connect(soundOut(ctx));
        _gain5.gain.setValueAtTime(0, t);
        _gain5.gain.linearRampToValueAtTime(0.2, t + 0.5);
        _gain5.gain.linearRampToValueAtTime(0, t + 1.5);
        _osc3.start(t);
        _osc3.stop(t + 1.5);
      }
    };

    // Loop synthesis split out from the toggle so the STUDENT MONITOR can start/stop the same
    // continuous wheeze/stridor purely from the synced `activeLoops` map (it previously never
    // reached students at all, because activeLoops was not in the payload).
    var startAudioLoop = function startAudioLoop(type) {
      var ctx = audioCtxRef.current;
      if (!ctx || loopNodesRef.current[type]) return;
      if (audioBlocked(ctx)) resumeAudio();
      try {
        var osc = ctx.createOscillator();
        var gain = ctx.createGain();
        var lfo = ctx.createOscillator();
        var lfoGain = ctx.createGain();
        if (type === 'Wheeze') {
          osc.type = 'triangle';
          osc.frequency.value = 400;
          lfo.frequency.value = 0.25;
          lfoGain.gain.value = 200;
        } else if (type === 'Stridor') {
          osc.type = 'sawtooth';
          osc.frequency.value = 600;
          lfo.frequency.value = 0.3;
          lfoGain.gain.value = 100;
        } else {
          osc.type = 'triangle';
          osc.frequency.value = 400;
          lfo.frequency.value = 0.25;
          lfoGain.gain.value = 150;
        }
        lfo.connect(lfoGain);
        lfoGain.connect(osc.frequency);
        osc.connect(gain);
        gain.connect(soundOut(ctx));
        var now = ctx.currentTime;
        gain.gain.setValueAtTime(0, now);
        gain.gain.value = 0.05;
        osc.start();
        lfo.start();
        loopNodesRef.current[type] = {
          stop: function stop() {
            try {
              gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
            } catch (e) {}
            setTimeout(function () {
              try {
                osc.stop();
                lfo.stop();
              } catch (e) {}
            }, 500);
          }
        };
      } catch (e) {
        console.warn('Audio loop failed to start', e);
      }
    };
    var stopAudioLoop = function stopAudioLoop(type) {
      if (!loopNodesRef.current[type]) return;
      loopNodesRef.current[type].stop();
      delete loopNodesRef.current[type];
    };
    var toggleAudioLoop = function toggleAudioLoop(type) {
      // WAVE 5 / ITEM 7 (same class of defect as the ROSC no-op): with no audio context yet
      // — the "Tap to Enable Sound" gesture not having happened — this returned silently, so the
      // button looked broken. Say why instead.
      if (!audioCtxRef.current) {
        _addLogEntry("Continuous sound \"".concat(type, "\" was not started: audio has not been enabled on this device yet. Tap the sound prompt on the monitor (or any control on this page) first."), 'warning');
        _dispatch({
          type: 'SET_NOTIFICATION',
          payload: {
            msg: 'Audio not enabled yet — tap to enable sound first',
            type: 'warning',
            id: Date.now()
          }
        });
        return;
      }
      if (loopNodesRef.current[type]) {
        stopAudioLoop(type);
        var newLoops = _objectSpread({}, state.activeLoops);
        delete newLoops[type];
        _dispatch({
          type: 'UPDATE_AUDIO_LOOPS',
          payload: newLoops
        });
        _addLogEntry("Audio Loop Stopped: ".concat(type), 'manual');
      } else {
        startAudioLoop(type);
        _dispatch({
          type: 'UPDATE_AUDIO_LOOPS',
          payload: _objectSpread(_objectSpread({}, state.activeLoops), {}, _defineProperty({}, type, true))
        });
        _addLogEntry("Audio Loop Started: ".concat(type), 'manual');
      }
    };

    // Reconcile the locally-playing loops with the synced state. Runs on both devices, so the
    // facilitator's mute and audio routing apply to continuous sounds as well.
    useEffect(function () {
      var current = state;
      var wanted = current.isMuted || !isAudioRouted(current) ? {} : current.activeLoops || {};
      Object.keys(loopNodesRef.current).forEach(function (type) {
        if (!wanted[type]) stopAudioLoop(type);
      });
      Object.keys(wanted).forEach(function (type) {
        if (wanted[type] && !loopNodesRef.current[type]) startAudioLoop(type);
      });
    }, [state.activeLoops, state.isMuted, state.audioOutput, isMonitorMode, audioCtxState, soundScreen]);

    // --- GROUP C: the AUTO / MANUAL deterioration toggle -------------------------------------
    // C3 is the critical requirement: "if switching from one to the other the obs should remain
    // the same at the point of switching." That is guaranteed structurally rather than by fixing
    // up numbers here — deterioration INTEGRATES into baseVitals, so the mode flag only gates
    // whether the integration runs. No vital is recomputed, re-snapshotted or reset by either
    // direction of the switch, so the displayed obs at second N are identical either way.
    var describeDeterioration = function describeDeterioration() {
      var cur = stateRef.current;
      var det = cur.scenario && cur.scenario.deterioration ? cur.scenario.deterioration : null;
      var type = det ? normaliseDeteriorationType(det.type) : null;
      var rate = det ? Number(det.rate) : 0;
      return {
        type: type,
        rate: Number.isFinite(rate) ? rate : 0,
        declared: !!(det && det.active !== false && type && rate > 0)
      };
    };
    var setDeteriorationMode = function setDeteriorationMode(mode) {
      var next = mode === 'auto' ? 'auto' : 'manual';
      var cur = stateRef.current;
      if (cur.deteriorationMode === next) return;
      var d = describeDeterioration();
      _dispatch({
        type: 'SET_DETERIORATION_MODE',
        payload: next
      });
      if (next === 'auto') {
        _addLogEntry(d.declared ? "Deterioration mode: AUTO \u2014 resuming ".concat(d.type, " decline at rate ").concat(d.rate, " FROM THE CURRENT OBS (HR ").concat(cur.vitals.hr, ", BP ").concat(cur.vitals.bpSys, ", SpO2 ").concat(cur.vitals.spO2, "%, RR ").concat(cur.vitals.rr, ", GCS ").concat(cur.vitals.gcs, ").") : 'Deterioration mode: AUTO — but this scenario declares no deterioration type/rate, so nothing will change on its own.', 'system');
      } else {
        _addLogEntry("Deterioration mode: MANUAL \u2014 autonomous change stopped at HR ".concat(cur.vitals.hr, ", BP ").concat(cur.vitals.bpSys, ", SpO2 ").concat(cur.vitals.spO2, "%, RR ").concat(cur.vitals.rr, ", GCS ").concat(cur.vitals.gcs, ". Obs unchanged; full manual control."), 'system');
      }
      _dispatch({
        type: 'SET_NOTIFICATION',
        payload: {
          msg: next === 'auto' ? 'AUTO: scenario deterioration active' : 'MANUAL: obs only change when you change them',
          type: 'info',
          id: Date.now()
        }
      });
    };
    var toggleDeteriorationMode = function toggleDeteriorationMode() {
      return setDeteriorationMode(stateRef.current.deteriorationMode === 'auto' ? 'manual' : 'auto');
    };

    // What the facilitator needs to see — which drugs are live, the phase they are in and how
    // long is left, so "why are the obs still moving?" always has a visible answer.
    // ---- WAVE 5 / ITEM 10: A LONG-ONSET DRUG MUST LOOK LIKE IT IS WORKING ------------------
    // IV paracetamol is correctly modelled (onset ~900 s, peak ~90 min, Temp -0.5), and correct
    // pharmacology means NOTHING moves inside a 4-minute sim segment. That is right and must not
    // be falsified — but the facilitator had no way to tell "working as intended, 12 minutes to
    // go" from "did nothing". The panel row now carries the countdown to onset, the countdown to
    // peak, and a plain-English summary of the effect that is coming.
    var EFFECT_WORDS = {
      HR: function HR(v) {
        return "HR ".concat(v > 0 ? '+' : '').concat(v);
      },
      BP: function BP(v) {
        return "BP ".concat(v > 0 ? '+' : '').concat(v, " mmHg");
      },
      RR: function RR(v) {
        return "RR ".concat(v > 0 ? '+' : '').concat(v);
      },
      SpO2: function SpO2(v) {
        return "SpO2 ".concat(v > 0 ? '+' : '').concat(v, "%");
      },
      gcs: function gcs(v) {
        return "GCS ".concat(v > 0 ? '+' : '').concat(v);
      },
      BM: function BM(v) {
        return "glucose ".concat(v > 0 ? '+' : '').concat(v, " mmol/L");
      },
      Temp: function Temp(v) {
        return "".concat(v < 0 ? "\u2212" : '+').concat(Math.abs(v), " \xB0C");
      },
      pH: function pH(v) {
        return "pH ".concat(v > 0 ? '+' : '').concat(v);
      },
      K: function K(v) {
        return "K+ ".concat(v > 0 ? '+' : '').concat(v, " mmol/L");
      },
      ETCO2: function ETCO2(v) {
        return "ETCO2 ".concat(v > 0 ? '+' : '').concat(v, " kPa");
      }
    };
    var describeDrugEffect = function describeDrugEffect(d) {
      var bits = [];
      var defn = (window.INTERVENTIONS || {})[d.key] || {};
      if (defn.antipyretic) bits.push('antipyretic');
      Object.keys(d.effect || {}).forEach(function (f) {
        var fn = EFFECT_WORDS[f];
        if (fn) bits.push(fn(d.effect[f]));
      });
      (d.drives || []).forEach(function (dr) {
        var per = Number(dr.ratePerHour);
        if (!Number.isFinite(per) || !per) return;
        var unit = dr.vital === 'temp' ? "\xB0C/h" : dr.vital === 'bm' ? 'mmol/L/h' : '/h';
        bits.push("".concat(dr.vital === 'temp' ? 'temperature' : dr.vital, " ").concat(per > 0 ? '+' : "\u2212").concat(Math.abs(per), " ").concat(unit).concat(dr.target !== null && dr.target !== undefined ? " towards ".concat(dr.target) : ''));
      });
      if (d.paralytic) bits.push('neuromuscular blockade');
      // ITEM 10: an agent whose modelled action is clinical rather than haemodynamic (the
      // anticonvulsants) must still say something, or its row looks broken.
      if (!bits.length) bits.push("clinical effect only \u2014 no modelled change to the obs");
      return bits.join(', ');
    };
    var getActiveDrugStatus = function getActiveDrugStatus() {
      var cur = stateRef.current;
      var t = cur.time;
      var rows = (cur.activeDrugs || []).map(function (d) {
        var factor = pkFactor(d, t);
        var remaining = pkRemaining(d, t);
        var el = t - d.startTime;
        // Live drive telemetry: current value, rate, target and an honest ETA, so a slow but
        // correct 2 degC/h of cooling is visibly in progress even between two 0.1 degC display
        // steps. `baseVitals` is the unrounded physiology, which is why sub-display-step
        // movement is real here and never lost (ITEM 9).
        var drives = (d.drives || []).map(function (dr) {
          var nowVal = cur.baseVitals ? cur.baseVitals[dr.vital] : undefined;
          var perHour = Number(dr.ratePerHour);
          var etaSeconds = null;
          if (Number.isFinite(nowVal) && Number.isFinite(perHour) && perHour !== 0 && dr.target !== null && dr.target !== undefined) {
            var gap = dr.target - nowVal;
            if (gap > 0 === perHour > 0 && Math.abs(gap) > 0.001) etaSeconds = Math.round(Math.abs(gap / perHour) * 3600);else etaSeconds = 0;
          }
          return {
            vital: dr.vital,
            ratePerHour: perHour,
            target: dr.target,
            current: Number.isFinite(nowVal) ? Math.round(nowVal * 100) / 100 : null,
            etaSeconds: etaSeconds,
            active: el >= d.onset
          };
        });
        return {
          key: d.key,
          label: d.label,
          phase: pkPhase(d, t),
          intensity: Math.round(Math.min(1, factor) * 100),
          remaining: remaining,
          elapsed: el,
          sustained: !!d.sustained,
          stopped: d.sustained && d.stopTime >= 0,
          paralytic: !!d.paralytic,
          reversed: !!d.reversed,
          effect: d.effect || {},
          // ITEM 10: countdowns and the plain-English expectation.
          onsetIn: Math.max(0, d.onset - el),
          peakIn: Math.max(0, d.peak - el),
          onsetSeconds: d.onset,
          peakSeconds: d.peak,
          expected: describeDrugEffect(d),
          drives: drives,
          route: d.route || null
        };
      }).filter(function (r) {
        return r.phase !== 'gone';
      });
      // Collapse repeat doses of the same drug into one row showing the dose count.
      var merged = {};
      rows.forEach(function (r) {
        var m = merged[r.key];
        if (!m) {
          merged[r.key] = _objectSpread(_objectSpread({}, r), {}, {
            doses: 1
          });
          return;
        }
        m.doses += 1;
        m.intensity = Math.min(100, m.intensity + r.intensity);
        if (r.remaining === null || m.remaining !== null && r.remaining > m.remaining) m.remaining = r.remaining;
        // Show the phase of the most recent dose, which is what is actually changing the obs.
        if (r.elapsed < m.elapsed) {
          m.phase = r.phase;
          m.elapsed = r.elapsed;
          m.onsetIn = r.onsetIn;
          m.peakIn = r.peakIn;
        }
      });
      return Object.values(merged);
    };
    var _start = function _start() {
      resumeAudio(true);
      // State the mode explicitly at scenario start so an untouched toggle is never a surprise.
      var d = describeDeterioration();
      var mode = stateRef.current.deteriorationMode;
      _addLogEntry(mode === 'auto' && d.declared ? "Deterioration mode: AUTO (scenario declares ".concat(d.type, ", rate ").concat(d.rate, ") \u2014 the patient will deteriorate on their own unless treated. Switch to MANUAL for full manual control.") : 'Deterioration mode: MANUAL — the obs will only change when you change them, or when a drug/trend you start changes them.', 'system');
      _dispatch({
        type: 'START_SIM'
      });
      // The patient goes live now: whatever was given before START starts acting from this
      // moment (pk drugs because state.time starts moving; instant effects and shocks here).
      // Only ever queued while not started, so a resume after a pause finds the queue empty.
      var pending = pendingEffectsRef.current;
      pendingEffectsRef.current = [];
      if (pending.length) {
        var labels = pending.map(function (p) {
          return p.label;
        }).filter(function (l, i, a) {
          return l && a.indexOf(l) === i;
        });
        if (labels.length) _addLogEntry("Given before START, acting from now: ".concat(labels.join(', '), "."), 'system');
        pending.forEach(function (p) {
          try {
            p.fn(stateRef.current);
          } catch (e) {
            console.error("Deferred effect of ".concat(p.key, " failed:"), e);
          }
        });
      }
    };
    var pause = function pause() {
      _dispatch({
        type: 'PAUSE_SIM'
      });
    };
    var stop = function stop() {
      _dispatch({
        type: 'STOP_SIM'
      });
    };
    var reset = function reset() {
      clearSimTimers();
      refibTimerRef.current = null;
      _dispatch({
        type: 'CLEAR_SESSION'
      });
    };
    // The controller has no scenario loaded (a fresh start, a reload before Resume, or after
    // Finish): take the last patient off the session so every patient screen goes back to
    // WAITING FOR CONTROLLER instead of showing a stale or default patient. The diff base is
    // dropped too, so the next scenario is sent whole. Controller only; never with a scenario.
    var clearLivePatient = function clearLivePatient() {
      var db = window.db;
      if (isMonitorMode || !db || !sessionID || stateRef.current.scenario) return;
      lastPayloadRef.current = {};
      db.ref("sessions/".concat(sessionID, "/live")).remove()["catch"](function (e) {
        return console.error('Could not clear the live patient:', e);
      });
    };
    // iPads and iPhones put web audio in the "ambient" category, which the Silent Mode switch (or
    // Control Centre's silent bell) mutes even though the context is running. Asking for the
    // "playback" category, as a media player does, lets it sound (Safari 16.4 and later). Older
    // Safari switches category when an <audio> element plays, so a moment of silence is played
    // inside the same gesture. Neither changes anything on other browsers.
    var silentAudioRef = useRef(null);
    var unmuteIos = function unmuteIos() {
      try {
        if (navigator.audioSession && navigator.audioSession.type !== 'playback') navigator.audioSession.type = 'playback';
      } catch (e) {}
      if (navigator.audioSession) return;
      var isIos = /iP(ad|hone|od)/.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
      if (!isIos) return;
      try {
        if (!silentAudioRef.current) {
          // 0.1 s of 8 kHz 8-bit mono silence as a WAV
          var n = 800,
            b = new Uint8Array(44 + n),
            v = new DataView(b.buffer);
          var str = function str(o, t) {
            for (var i = 0; i < t.length; i++) b[o + i] = t.charCodeAt(i);
          };
          str(0, 'RIFF');
          v.setUint32(4, 36 + n, true);
          str(8, 'WAVEfmt ');
          v.setUint32(16, 16, true);
          v.setUint16(20, 1, true);
          v.setUint16(22, 1, true);
          v.setUint32(24, 8000, true);
          v.setUint32(28, 8000, true);
          v.setUint16(32, 1, true);
          v.setUint16(34, 8, true);
          str(36, 'data');
          v.setUint32(40, n, true);
          b.fill(128, 44);
          var bin = '';
          b.forEach(function (x) {
            bin += String.fromCharCode(x);
          });
          var el = document.createElement('audio');
          el.setAttribute('playsinline', '');
          el.setAttribute('x-webkit-airplay', 'deny');
          el.preload = 'auto';
          el.src = 'data:audio/wav;base64,' + btoa(bin);
          silentAudioRef.current = el;
        }
        var pr = silentAudioRef.current.play();
        if (pr && pr["catch"]) pr["catch"](function () {});
      } catch (e) {}
    };
    // Called from the monitor's "Tap to Enable Sound" overlay, i.e. inside a real user gesture:
    // resume properly (awaiting the promise) and prime with a silent buffer for iOS.
    var enableAudio = function enableAudio() {
      unmuteIos();
      var p = resumeAudio(true);
      if (window.speechSynthesis) {
        try {
          if (window.speechSynthesis.paused) window.speechSynthesis.resume();
          // Speaking an empty utterance inside the gesture unlocks TTS on iOS Safari.
          var warm = new SpeechSynthesisUtterance(' ');
          warm.volume = 0;
          window.speechSynthesis.speak(warm);
        } catch (e) {}
      }
      return p;
    };
    useEffect(function () {
      // Physiology is owned by the controller. isRunning is now synced so the monitor can make
      // sound, but the monitor must NOT run its own 1 Hz physiology tick or it would fight the
      // authoritative vitals arriving over Firebase.
      // The decision of WHAT to tick is tickActionFor's, not this effect's: nothing before
      // START, the full pipeline while running, and a ramp alone while paused.
      var action = tickActionFor(state, isMonitorMode);
      if (action) {
        timerRef.current = setInterval(function () {
          tickRef.current = Date.now();
          _dispatch({
            type: action
          });
        }, 1000);
      } else {
        if (timerRef.current) clearInterval(timerRef.current);
      }
      return function () {
        if (timerRef.current) clearInterval(timerRef.current);
      };
    }, [state.isRunning, isMonitorMode, !!(state.trends && state.trends.active), state.pausedAt, state.isFinished]);

    // =====================================================================================
    // EVERY MONITORING CHIP IS A TRUE TWO-WAY TOGGLE.
    // One press attaches, the next press DETACHES, and the chip's own state is what decides
    // which. The whole class of confusion came from the chip reading its state through
    // getSensors() (so 'Obs' made it look attached) while pressing it applied its INDIVIDUAL
    // key: the press was a no-op to look at. Attachment and detachment are both logged, so both
    // appear in the timeline and the debrief.
    //
    // Not a toggle, deliberately: a point-of-care check. Repeating a glucose or a VBG takes a
    // FRESH, newly-timestamped sample, which is the clinically important behaviour and is what
    // a facilitator pressing it again means.
    // =====================================================================================
    // =====================================================================================
    // EVERY BATCH ATTACH/DETACH IS ONE REDUCER ACTION.
    //
    // ROOT CAUSE of the "+ INVASIVE attaches the art line but not IV" bug: these helpers used
    // to make SEQUENTIAL applyIntervention() calls. React 18 batches everything a click handler
    // dispatches into ONE commit, and `stateRef.current` is only refreshed by an effect AFTER a
    // commit — so every call in the batch read the SAME pre-press snapshot and sent a
    // whole-replacement `activeInterventions` Set built from it. The last dispatch won and the
    // earlier attachment vanished, while BOTH log lines were still written (which is exactly
    // what the live event log showed at 00:39).
    //
    // Both halves are fixed: UPDATE_INTERVENTION_STATE is now a delta (so even sequential
    // dispatches compose), and every batch path below resolves to a SINGLE ATTACH_SENSORS /
    // DETACH_SENSORS action, decided from one snapshot and applied atomically in the reducer.
    // Each sensor is logged exactly once, only when it genuinely changed.
    // =====================================================================================
    var sensorDefFor = function sensorDefFor(idOrKey) {
      return SENSOR_DEFS.filter(function (d) {
        return d.id === idOrKey || d.key === idOrKey;
      })[0] || null;
    };
    // 'Obs' is the long-standing SHORTHAND for the standard four (all 254 scenarios, saved
    // sessions and sync payloads use it), so it stays a first-class batch member.
    var sensorKeyOf = function sensorKeyOf(idOrKey) {
      return idOrKey === 'Obs' ? 'Obs' : (sensorDefFor(idOrKey) || {}).key || null;
    };
    var isSensorAttached = function isSensorAttached(s, key) {
      if (key === 'Obs') return s.standard;
      var def = sensorDefFor(key);
      return def ? !!s[def.id] : false;
    };
    // The objective/stabiliser credit an intervention earns, factored out of applyIntervention so
    // a batched attach credits exactly what an individual press would.
    var creditIntervention = function creditIntervention(key, scenario) {
      keywordObjectivesFor(scenario, key).forEach(function (obj) {
        return _dispatch({
          type: 'COMPLETE_OBJECTIVE',
          payload: obj
        });
      });
      if (scenario.stabilisers && scenario.stabilisers.includes(key)) {
        _dispatch({
          type: 'TRIGGER_IMPROVE'
        });
        _addLogEntry("Patient condition IMPROVING", "success");
      }
    };
    // PATIENT SET-UP (before START): kit already on the patient when the team arrives, such as
    // tourniquets, a cannula or an oxygen mask. It is shown on the picture and counts as on
    // (the team can take it off), but it is not the team's action: no effect on the obs (the
    // obs set for the scenario are the obs with this kit on), no objective credit, no
    // countdown. A second press takes it off again.
    var setUpIntervention = function setUpIntervention(key) {
      var cur = stateRef.current;
      var action = INTERVENTIONS[key];
      if (!cur.scenario || !action) return;
      var sensor = key === 'Obs' || STANDARD_SENSOR_KEYS.indexOf(key) !== -1;
      var on = sensor ? isSensorAttached(getSensors(cur), key) : cur.activeInterventions.has(key);
      // Remembered on the scenario (scenario.setupKit) so the debrief does not count it as the team's.
      var kitList = (Array.isArray(cur.scenario.setupKit) ? cur.scenario.setupKit : []).filter(function (k) {
        return k !== key;
      });
      _dispatch({
        type: 'UPDATE_SCENARIO',
        payload: _objectSpread(_objectSpread({}, cur.scenario), {}, {
          setupKit: on ? kitList : kitList.concat([key])
        })
      });
      if (on) {
        _dispatch(sensor ? {
          type: 'DETACH_SENSOR',
          payload: key
        } : {
          type: 'REMOVE_INTERVENTION',
          payload: key
        });
        dropPendingEffects(key);
        _addLogEntry("Set-up: ".concat(action.label, " taken off again."), 'system');
        return;
      }
      _dispatch({
        type: 'UPDATE_INTERVENTION_STATE',
        payload: {
          add: [key],
          inc: []
        }
      });
      _addLogEntry("Set-up: ".concat(action.label, " already in place when the team arrives."), 'system');
    };
    var attachSensors = function attachSensors(keys) {
      var cur = stateRef.current;
      if (!cur.scenario) {
        console.warn('attachSensors ignored: no scenario is loaded.');
        _dispatch({
          type: 'SET_NOTIFICATION',
          payload: {
            msg: 'No scenario loaded — load a scenario first.',
            type: 'danger',
            id: Date.now()
          }
        });
        return;
      }
      var list = (Array.isArray(keys) ? keys : [keys]).map(sensorKeyOf).filter(function (k) {
        return !!k;
      });
      var s0 = getSensors(cur);
      var add = [],
        logs = [];
      var etco2 = null;
      list.forEach(function (key) {
        if (isSensorAttached(s0, key)) return; // already on: never logged twice
        if (add.indexOf(key) !== -1) return; // de-duplicated within the batch
        if (key === 'ToggleETCO2') {
          etco2 = true;
          logs.push('ETCO2 Connected');
          return;
        }
        add.push(key);
        var def = INTERVENTIONS[key];
        logs.push(def && def.log || "".concat(key, " attached."));
      });
      if (!add.length && etco2 === null) {
        _dispatch({
          type: 'SET_NOTIFICATION',
          payload: {
            msg: 'Already attached — nothing to add.',
            type: 'info',
            id: Date.now()
          }
        });
        return;
      }
      // ONE action for the whole batch: sensor set, durations and capnography together.
      _dispatch({
        type: 'ATTACH_SENSORS',
        payload: {
          keys: add,
          etco2: etco2 === null ? undefined : etco2
        }
      });
      logs.forEach(function (msg) {
        return _addLogEntry(msg, 'action');
      });
      // Permissive as ever: an unmet expectation is FLAGGED, never blocking.
      add.forEach(function (key) {
        var def = INTERVENTIONS[key];
        if (!def) return;
        var missing = _getUnmetExpectations(def, cur);
        if (missing.length) _addLogEntry("".concat(def.label, " performed WITHOUT: ").concat(missing.join(', ')), 'warning', true, {
          action: key,
          label: def.label,
          missing: missing
        });
        creditIntervention(key, cur.scenario);
      });
      var labels = add.map(function (k) {
        return INTERVENTIONS[k] && INTERVENTIONS[k].label || k;
      }).concat(etco2 ? ['Capnography'] : []);
      _dispatch({
        type: 'SET_NOTIFICATION',
        payload: {
          msg: "".concat(labels.join(' + '), " attached"),
          type: 'success',
          id: Date.now()
        }
      });
    };
    var detachSensors = function detachSensors(keys) {
      var cur = stateRef.current;
      var list = (Array.isArray(keys) ? keys : [keys]).map(sensorKeyOf).filter(function (k) {
        return !!k;
      });
      var s0 = getSensors(cur);
      var remove = [];
      list.forEach(function (key) {
        if (!isSensorAttached(s0, key)) return; // already off: no phantom log
        if (remove.indexOf(key) === -1) remove.push(key);
      });
      if (!remove.length) return;
      _dispatch({
        type: 'DETACH_SENSORS',
        payload: {
          keys: remove
        }
      });
      remove.forEach(function (key) {
        var def = sensorDefFor(key);
        if (def) _addLogEntry("".concat(def.label, " removed \u2014 ").concat(def.reveals, " no longer visible to the team."), 'action');else _addLogEntry("".concat(INTERVENTIONS[key] && INTERVENTIONS[key].label || key, " removed."), 'action');
      });
      var labels = remove.map(function (k) {
        return (sensorDefFor(k) || INTERVENTIONS[k] || {}).label || k;
      });
      _dispatch({
        type: 'SET_NOTIFICATION',
        payload: {
          msg: "".concat(labels.join(' + '), " DETACHED (press again to re-attach)"),
          type: 'info',
          id: Date.now()
        }
      });
    };
    var toggleSensor = function toggleSensor(id) {
      var cur = stateRef.current;
      var def = SENSOR_DEFS.filter(function (d) {
        return d.id === id;
      })[0];
      if (!def) {
        console.warn("toggleSensor('".concat(id, "') ignored: no such sensor."));
        return;
      }
      if (def.kind === 'poc') {
        applyIntervention(def.key);
        return;
      }
      var on = !!getSensors(cur)[def.id];
      if (on) detachSensors([def.key]);else attachSensors([def.key]);
    };
    // The fast path attaches the STANDARD four and says so. The invasive
    // action is separate and explicitly labelled, because an arterial line, IV access and
    // capnography are deliberate clinical acts, not a default.
    // Both are single atomic actions.
    var attachStandardMonitoring = function attachStandardMonitoring() {
      return attachSensors(['Obs']);
    };
    var attachInvasiveMonitoring = function attachInvasiveMonitoring() {
      return attachSensors(INVASIVE_SENSOR_KEYS);
    };
    return {
      state: state,
      dispatch: _dispatch,
      start: _start,
      pause: pause,
      stop: stop,
      reset: reset,
      clearLivePatient: clearLivePatient,
      notStarted: function notStarted() {
        return _notStarted(stateRef.current);
      },
      applyIntervention: applyIntervention,
      setUpIntervention: setUpIntervention,
      addLogEntry: _addLogEntry,
      manualUpdateVital: manualUpdateVital,
      manualUpdateVitals: manualUpdateVitals,
      triggerArrest: triggerArrest,
      triggerROSC: triggerROSC,
      revealInvestigation: revealInvestigation,
      clearInvestigation: clearInvestigation,
      nextCycle: nextCycle,
      enableAudio: enableAudio,
      speak: speak,
      playSound: playSound,
      toggleAudioLoop: toggleAudioLoop,
      startTrend: startTrend,
      triggerNIBP: triggerNIBP,
      stopNIBP: stopNIBP,
      toggleNIBPMode: toggleNIBPMode,
      triggerAction: triggerAction,
      initCharge: _initCharge,
      deliverShock: _deliverShock,
      playAlertTone: playAlertTone,
      // Wave 3 surface
      changeRhythm: changeRhythm,
      applyCardioversion: function applyCardioversion(o) {
        return _applyCardioversion(stateRef.current, o || {});
      },
      setDefibMode: _setDefibMode,
      setDefibEnergy: _setDefibEnergy,
      toggleDefibSync: toggleDefibSync,
      analyseRhythm: _analyseRhythm,
      setQueuedRhythm: setQueuedRhythm,
      toggleCPR: _toggleCPR,
      // Defib Sim controller
      goToDefibStep: goToDefibStep,
      setMetronome: function setMetronome(on) {
        _dispatch({
          type: 'SET_METRONOME',
          payload: !!on
        });
        _addLogEntry("CPR metronome ".concat(on ? 'ON' : 'OFF', " (on the defib)"), 'system');
      },
      setNoise: function setNoise(patch) {
        _dispatch({
          type: 'SET_NOISE',
          payload: patch
        });
        var names = {
          interference: 'mains interference',
          movement: 'movement artefact',
          leadoff: 'lead off',
          tremor: 'shivering / tremor'
        };
        var styles = {
          normal: 'normal',
          poor: 'poor peripheral perfusion',
          motion: 'motion artefact',
          swing: 'respiratory swing',
          overdamped: 'overdamped',
          underdamped: 'underdamped'
        };
        Object.keys(patch || {}).forEach(function (k) {
          if (names[k]) _addLogEntry("Artefact: ".concat(names[k], " ").concat(patch[k] ? 'ON' : 'OFF'), 'system');
          if (k === 'pleth' && styles[patch[k]]) _addLogEntry("Pleth trace: ".concat(styles[patch[k]]), 'system');
          if (k === 'art' && styles[patch[k]]) _addLogEntry("Arterial trace: ".concat(styles[patch[k]]), 'system');
          if (k === 'artFlush' && patch[k]) _addLogEntry('Arterial line flush test', 'system');
        });
      },
      setDefibSettings: function setDefibSettings(patch) {
        _dispatch({
          type: 'SET_DEFIB_SETTINGS',
          payload: patch
        });
        var say = function say(k, v) {
          return k === 'cvEnergy' ? "cardioversion succeeds at ".concat(v === 'default' ? 'the default energy' : "".concat(v, " J or more")) : "".concat(k, " = ").concat(v);
        };
        _addLogEntry("Shock response settings: ".concat(Object.keys(patch || {}).map(function (k) {
          return say(k, patch[k]);
        }).join(', ')), 'system');
      },
      sendDeviceEvent: sendDeviceEvent,
      sendVentCommand: sendVentCommand,
      recommendedShockEnergy: recommendedShockEnergy,
      defibEnergySteps: function defibEnergySteps() {
        var _stateRef$current$sce;
        return RG.energySteps(defibWeight(), (_stateRef$current$sce = stateRef.current.scenario) === null || _stateRef$current$sce === void 0 ? void 0 : _stateRef$current$sce.patientAge);
      },
      audioContextState: audioCtxState,
      getUnmetExpectations: function getUnmetExpectations(action) {
        return _getUnmetExpectations(action, stateRef.current);
      },
      setDeteriorationMode: setDeteriorationMode,
      toggleDeteriorationMode: toggleDeteriorationMode,
      describeDeterioration: describeDeterioration,
      getActiveDrugStatus: getActiveDrugStatus,
      // Wave 8 surface: two-way sensor toggles, the honest fast paths and the derived obstruction.
      toggleSensor: toggleSensor,
      attachStandardMonitoring: attachStandardMonitoring,
      attachInvasiveMonitoring: attachInvasiveMonitoring,
      // Wave 9 surface: the atomic batch primitives themselves, so any future multi-sensor button
      // is one action by construction rather than a sequence of presses.
      attachSensors: attachSensors,
      detachSensors: detachSensors,
      getObstruction: function getObstruction() {
        return _getObstruction(stateRef.current, stateRef.current.vitals, stateRef.current.scenario);
      }
    };
  };
  window.useSimulation = useSimulation;
})();